import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { EventServicesService } from 'src/app/services/event-services.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { saveAs } from 'file-saver';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { nanoid } from 'nanoid';
import moment from 'moment';
import { DatePipe } from '@angular/common';
// import * as domicileFile from '../../../assets/Json/domicileState.json';
// import * as specializationFile from '../../../assets/Json/specializationList.json';
import { CandidateStatus } from '../candidate-list/candidate-list.component';
import { candidateStatus, statusColorMapping} from 'src/app/enum/candidate-status.enum';
import { ThisReceiver } from '@angular/compiler';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { FieldLookupService } from 'src/app/services/field-lookup.service';
import { SettingsService } from 'src/app/services/settings.service';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { MultiSelect, MultiSelectFilterEvent } from 'primeng/multiselect';
import { realignMultiSelectOverlay } from 'src/app/utils/dropdown-realign';


interface FilterCriteria {
  filterField: string,
  filterValue: string
}


interface InterviewBulkSchedule {
  error_file?: string;
  detail?: string | Array<{ msg?: string; ctx?: { error?: string } }>;
}

interface ConferenceProvider {
  name: string;
  key: string;
  category: string;
  is_integrated: boolean;
  selectDisabled?: boolean;
}

@Component({
    selector: 'app-stage-candidates',
    templateUrl: './stage-candidates.component.html',
    styleUrls: ['./stage-candidates.component.css'],
    providers: [MessageService, DatePipe],
    standalone: false
})
export class StageCandidatesComponent implements OnInit, OnChanges, OnDestroy {
  instituteSearch$: Subject<void> = new Subject<void>();

  @ViewChild('cohortOP') cohortOP: any;
  @ViewChild('cohortDropdown') cohortDropdown: any;
  @ViewChild('errorReport') errorReport: any;
  @ViewChild('feedbackFormComponent') feedbackFormComponent: any;

  @HostListener('window:scroll', ['$event'])
  onScrollEvent(event: any) {
    if (this.cohortDetails) {
      this.cohortOP.hide();
      this.cohortDropdown.nativeElement.blur();
      this.cohortDropdown.hide();
    }
  }

  @Input() stage: any;
  @Input() stages: any;
  @Input() initialStatus: string = '';
  private appliedStatusFilter: string = '';
  @Input() contestId: string = '';
  @Input() testId: string = '';
  @Input() search: any = [];
  @Input() isFeedbackSelected: any;
  @Input() isTestSelected: any;
  @Input() set emailsCleared(value: boolean) {
    if (value) {
      this.search = [];
      if (this.stage) {
        this.getCandidates();
      }
    }
  }

  @Output() emptyStage = new EventEmitter<boolean>();
  @Output() emailList = new EventEmitter<any>();
  @Output() candidateCount = new EventEmitter<any>();

  pageLimits: Array<number> = [];
  candidatesCol: Array<any> = [];
  _selectedColumns: Array<any> = [];
  candidateList: any[] = [];
  selectedUsersList: any = [];
  checkedColumns: Array<any> = [];
  columnsToSave: Array<any> = [];
  _candidatesCol: Array<any> = [];
  savedColumnSettings: Array<any> = [];
  colsToDownload: Array<any> = [];
  stageList: Array<any> = [];
  sourceData: Array<any> = [];
  emails: Array<string> = [];
  allCandidateDetails: any = [];
  excel: File[] = [];
  cohortExcel: File[] = [];
  template: File[] = [];
  cohortFile: File[] = [];
  cohortErroredFile: Array<any> = [];
  bucketData: any = {};
  statusOptions: Array<any> = [];
  timeSlots: Array<any> = [];
  copyTimeSlots: Array<any> = [];
  candidateStatus: any = {};
  // statusColor: Array<any> = [];
  loggedUserDetails: any = {};
  stageToMove: any = 0;
  activitySliderOptions: any = {};
  cohortStatuses: Array<any> = [];
  _cohortStatuses: Array<any> = [];
  selectedCohortStatus: any = {};
  newCohortStatus: any = {};
  eventUsers: any = [];
  selectedEventDetails: any;
  assignedCohortData: any = [];
  rangeDates: any = [new Date()];
  currentStatus: any;
  showJoiningDate: any;
  selectedJoinDate: any;
  selectedBranch: any;
  selectedDegree: any;
  selectedCollege: any;
  selectedSpecial: any = '';
  selectedYearDate: Date | null = null;
  selectedRole: any = [];
  selectedArrears: any = null;
  selectedPwd: any = null;
  selectedGender: any = null;
  selectedEligibility: any = '';
  branchList: any = [];
  collegeList: any = [];
  roleList: Array<{ label: string; value: string }> = [];
  // specialList: any = (specializationFile as any).default;
  // domicileList: any = (domicileFile as any).default;

  marksPercentList: any;
  genderList: any;
  arrearList: any;
  eligibleList: any;
  pwdList: any;
  // yearList: Array<{ label: string, value: number }> = [];
  statusFilterOptions: Array<any> = [];
  statusActionOptions: Array<any> = [];
  // ugList:any;
  // hscList:any;
  // sslcList:any;



  order_by: string = 'asc';
  sort_by: string = 'candidate_uuid';
  exportName: string = 'candidateList';
  cohortName: string = 'cohort_template';
  jobId: string = '';
  eventId: string = '';
  eventName: string = '';
  columnSearchTerm: string = '';
  downloadSearchTerm: string = '';
  downloadAs: string = 'excel';
  scheduleRadio: string = 'all';
  bulkScheduleSendEmail: boolean = true;
  companyId: string = '';
  fileBase64: string = '';
  templateFile: string = '';
  activityRemarks: string = '';
  interviewFileName: string = '';
  testFileName: string = '';
  stageType: string = '';
  cohortNameTerm: string = '';
  delayedStyle: string = '';
  sendMailHeader: string = '';

  loadingSpinner: boolean = false;
  syncScoresLoading: boolean = false;
  syncContestLoading: boolean = false;
  showFilterSidebar: boolean = false;
  showSettingsSidebar: boolean = false;
  showDownloadSidebar: boolean = false;
  displayUserDetails: boolean = false;
  displaySaveColumnSettings: boolean = false;
  showUploadSlider: boolean = false;
  showScheduleSlider: boolean = false;
  showTestScheduleSlider: boolean = false;
  uploadingFile: boolean = false;
  cohortUploadingFile: boolean = false;
  loadingDownload: boolean = false;
  uploadBtnLoading: boolean = false;
  scheduleBtnLoading: boolean = false;
  testScheduleBtnLoading: boolean = false;
  cohortBtnLoading: boolean = false;
  inEditMode: boolean = false;
  sendLinkSlider: boolean = false;
  clicked: boolean = false;
  templateUploaded: boolean = false;
  cohortLoader: boolean = false;
  templateLoader: boolean = false;
  excelValidation: boolean = false;
  stageActivitySlider: boolean = false;
  locationJobRoleDetails: boolean = false;
  cohortDetails: boolean = false;
  createCohortTable: boolean = false;
  selectCohortTable: boolean = false;
  loadingCohort: boolean = false;
  errorMessage = { isError: false, message: 'Kindly fill all the fields!' };
  clickedCohort: boolean = false;
  show: boolean = false;
  cohortUploadSuccess: boolean = false;
  cohortUploadFailed: boolean = false;
  sendDocumentation: boolean = false;
  sentInterviewVenue: boolean = false;
  filterLoading: boolean = false;
  invalidNumber: boolean = false;
  showSyncScoresConfirmDialog: boolean = false;
  showSyncContestConfirmDialog: boolean = false;
  selectedAllStageCandidates: boolean = false;
  showDocumentationDialog: boolean = false;
  showFeedbackDialog: boolean = false;
  isLoadingDetails: boolean = false;
  documentationDetails: any[] = [];
  feedbackDetailsData: any[] = [];
  documentationSections: { name: string, fields: any[] }[] = [];
  feedbackSections: { name: string, fields: any[] }[] = [];
  allDocumentationDetails: { [key: number]: any[] } = {};
  allFeedbackDetails: { [key: number]: any[] } = {};
  documentationFormId: number | null = null;
  feedbackFormId: number | null = null;
  feedbackSlider: boolean = false;
  feedbackMode: string = 'view'; // 'create', 'view', 'edit'
  selectedCandidateForFeedback: any = null;
  feedbackFormUuid: string = '';
  feedbackHeaderData: any = {};
  panelMembers: any[] = [];
  groupedPanelMembers: { label: string, interview_uuid: string, members: any[] }[] = [];
  selectedPanelMemberId: number | null = null;
  selectedPanelMemberFormId: number | null = null;
  currentUserId: number = 0;
  isViewOnlyFeedback: boolean = false;
  originalFeedbackMode: string = 'view';
  changeStatusOptions: Array<any> = [];
  skeletonData: any[] = Array(10).fill({}).map((_, index) => ({
    id: `skeleton-${index}`,
    name: '',
    email: '',
    status: '',
    stageId: '',
    collegeName: '',
    mobile_number: '',}));

  first: number = 1;
  last: number = 10;
  pageSize: number = 10;
  pageNumber: number = 1;
  totalLength: number = 0;
  timeDuration: number = 0;
  activeTabIndex: number[] = [0];
  filterCount: number = 0;
  testRange: [number, number] = [0, 100];
  startValue: number = 0;
  endValue: number = 100;
  totalPages: number = 1;
  numberOfStages: number = 0;

  firstValue: any;
  secondValue: any;
  selectedUser: any;
  startTime: any;
  endTime: any;
  templateSize: any;
  fileCopy: any;
  cohortUploadCopy: any;
  dateFormat: any;
  timeFormat: any;
  privilege: any;
  testStartRange: any;
  testEndRange: any;
  remarks: string = '';

  currentDate = new Date();
  joiningCurrentDate = new Date();


  columnSettings: FormGroup = new FormGroup({
    columnName: new FormControl(''),
    columnValue: new FormControl(this.columnsToSave),
  });

  sendLinkForm: FormGroup = new FormGroup({});
  eventCategory: string = '';
  sendEmailSlider: boolean = false;
  sendOfferMail: boolean = false;
  fromAddress = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_metadata?.from_email : '';
  filterCriteria: Array<FilterCriteria> = [];
  assessmentRange: any = [new Date()];
  contestValidityRange: any = [new Date()];
  filterApplied: boolean = false;
  durationSlots = this.generateDurationSlots();
  errorFileUrl: string = '';
  userPrivileges: Set<string> = new Set();
  bulkMoveStageLimit: number = 2500;
  bulkSendTestLinkLimit: number = 2500;
  bulkInterviewScheduleLimit: number = 2500;
  registrationFormId: string = '';
  registrationFormFields: Array<any> = [];
  filterFieldVisibility: { [key: string]: boolean } = {};
  filterFieldTypes: { [key: string]: string } = {};
  
  formData: any;
  jobRoles: Array<{ label: string; value: string }> = [];
  interviewJobRoles: Array<{ label: string; value: number }> = [];
  preferredLocations: Array<{ label: string; value: string }> = [];
  agents: Array<{ label: string; value: string }> = [];
  instituteList: any;
  certificateList: any;
  languagesList: any;
  skillsList: any;
  sscBoardsList: any;
  intermediateBoardsList: any;
  entranceTestsList: any;
  educationBranchesList: any = [];
  educationDegreesList: any = [];
  degreeList: any = [];
  selectAllColumns: boolean = false;

  // Conference providers for interview
  conferenceProviders: ConferenceProvider[] = [];
  selectedConferenceProvider: ConferenceProvider | null = null;
  isLoadingProviders: boolean = false;
  providersLoaded: boolean = false;

  // Default Jitsi provider
  defaultJitsiProvider: ConferenceProvider = {
    name: 'Default',
    key: 'default',
    category: 'conferencing',
    is_integrated: true
  };

  lastConnectedProvider: ConferenceProvider | null = null;

  get isExternalProviderSelected(): boolean {
    return this.stage?.type === 'Online Interview' && !!this.selectedConferenceProvider && this.selectedConferenceProvider.key !== 'default';
  }

  interviewerList: Array<{ label: string; value: number; userId: number; email?: string }> = [];
  selectedInterviewers: number[] = [];
  interviewerListLoaded: boolean = false;

  showAvailabilityPanel: boolean = false;
  isLoadingAvailability: boolean = false;
  availabilityData: Array<{ id: number; name: string; email: string; availability: number[] }> = [];
  timelineScrollOffset: number = 0;
  visibleSlotsCount: number = 12;
  allTimeSlots: string[] = [];
  availabilityBaseHour: number = 9;
  availabilityBaseMinute: number = 0;

  selectedPwdText: string = '';
  selectedRoleText: string = '';
  selectedArrearsText: string = '';
  selectedGenderText: string = '';
  selectedBranchText: string = '';
  selectedDegreeText: string = '';
  selectedCollegeText: string = '';
  filterBackup: any = {};
  selectedCollegeList: any[] = [];

  constructor(
    private jobService: JobServicesService,
    private eventServices: EventServicesService,
    private fileUploadService: FileUploadService,
    private messageService: MessageService,
    private globalService: GlobalServicesService,
    private sharedServicesService: SharedServicesService,
    private datePipe: DatePipe,
    private cdRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private formBuilderService: FormBuilderService,
    private fieldLookupService: FieldLookupService,
    private settingsService: SettingsService
  ) {
    this.jobId = localStorage.getItem('selectedJobId') || '';
    this.activatedRoute.paramMap.subscribe(params => {
      this.eventId = params.get('eventId') || '';
    });
    this.eventName = window.localStorage.getItem('selectedEventName') || '';

    this.companyId = localStorage.getItem('companyUUID') ?? '';

    this.pageLimits = [10, 25, 50, 100];

    this.candidatesCol = [
      { index: 1, field: 'email', header: 'E-mail', sortable: true },
      { index: 2, field: 'status', header: 'Status', options: [{ label: 'All', value: '' }], selectedFilterElement: { label: 'All', value: '' }, sortable: true },
      // { index: 3, field: 'stageId', header: 'Stage' },
      { index: 4, field: 'collegeName', header: 'College Name' , sortable: true},
      { index: 9, field: 'mobile_number', header: 'Phone' },
      { index: 10, field: 'gender', header: 'Gender', sortable: true},
      { index: 11, field: 'dob', header: 'Date Of Birth' }
    ]

    this._selectedColumns = [
      { index: 1, field: 'email', header: 'E-mail', sortable: true },
      { index: 2, field: 'status', header: 'Status', options: [{ label: 'All', value: '' }], selectedFilterElement: { label: 'All', value: '' }, sortable: true },
      // { index: 3, field: 'stageId', header: 'Stage' },
      { index: 4, field: 'collegeName', header: 'College Name', sortable: true},
      // { index: 9, field: 'mobile_number', header: 'Phone' },
      { index: 10, field: 'gender', header: 'Gender',sortable: true },
      { index: 11, field: 'dob', header: 'Date Of Birth' }
    ]

    this.timeSlots = this.generateTimeSlots();

    this.sendLinkForm = new FormGroup({
      candidates: new FormControl([]),
      interviewDate: new FormControl(null, [Validators.required]),
      startTime: new FormControl(null, [Validators.required]),
      duration: new FormControl(null, [Validators.required]),
      jobRoleId: new FormControl(null, [Validators.required]),
      venue: new FormControl(null, this.stage?.type === 'Offline Interview' ? [Validators.required, Validators.maxLength(250)] : [Validators.maxLength(250)]),
      sendEmail: new FormControl(true),
      agentId: new FormControl(null, this.stage?.type === 'AI Interview' ? [Validators.required] : [])
    });
  }
  ngOnInit(): void {
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
    this.timeFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.time_format : '';
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.sharedServicesService.metadata$.subscribe((metadata: any) => {
      if (metadata?.bulk_candidate_move_stage_limit) {
        this.bulkMoveStageLimit = metadata.bulk_candidate_move_stage_limit;
      }
      if (metadata?.bulk_candidate_send_test_link_limit) {
        this.bulkSendTestLinkLimit = metadata.bulk_candidate_send_test_link_limit;
      }
      if (metadata?.bulk_interview_schedule_limit) {
        this.bulkInterviewScheduleLimit = metadata.bulk_interview_schedule_limit;
      }
    });
    
    this.loadInterviewJobRoles();


    this.filterFieldVisibility = {
      isPWD: false,
      jobRole: false,
      arrears: false,
      gender: false,
      graduationYear: false,
      degreeBranch: false,
      degree: false,
      collegeName: false
    };
    
    this.addColumns();
    this.sourceData = [
      {
        fieldName: 'stageId',
        value: this.stage.stageId,
        fieldType: 'number',
      },
      {
        fieldName: 'jobStatus',
        value: 'pending',
        fieldType: 'string',
      },
    ];
    this.statusOptions = this.stage.actions;
    this.candidatesCol.find((col: any) => col.field == 'status').options.push(...this.statusOptions);
    this._selectedColumns.find((col: any) => col.field == 'status').options.push(...this.statusOptions);

    if (this.stage?.actions?.length) {
      this.statusActionOptions = this.stage.actions;    
      this.statusFilterOptions = this.stage.actions
        .map((action: any) => ({
          label: action.name,
          value: action.name
        })).filter((filter: any) => !["move stage", "send email", "send test link", "send interview link", "send interview venue", "send documentation link", "send offer"].includes(filter.label.toLowerCase()));
      const statusCol = this.candidatesCol.find(col => col.field === 'status');
      const selectedStatusCol = this._selectedColumns.find(col => col.field === 'status');
    
      if (statusCol && statusCol.options) {
        statusCol.options = [{ label: 'All', value: '' }, ...this.statusFilterOptions];
      }
    
      if (selectedStatusCol && selectedStatusCol.options) {
        selectedStatusCol.options = [{ label: 'All', value: '' }, ...this.statusFilterOptions];
      }
    }
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    this.currentUserId = userDetails?.id || 0;
    this.globalService.userMeta$.subscribe(meta => {
      this.loggedUserDetails = meta?.user_profile || {};
      if (this.loggedUserDetails?.id) {
        this.currentUserId = this.loggedUserDetails.id;
      }
    });

    // Apply a deep-linked status filter (from the Overview tab) before the first load.
    this.applyDeepLinkStatus(false);

    this.getCandidates();
    // this.getAllUsers();
    this._candidatesCol = this.candidatesCol;
    this.colsToDownload = this.candidatesCol;
    this.checkedColumns = this._selectedColumns;

    if (this.stages) {
      this.stages.forEach((stage: any) => {
        if (this.stage.stageId !== stage.stageId) {
          this.stageList.push({ name: stage.name, stageId: stage.stageId, type: stage.type });
        }
      });
    }

    this.candidateStatus = candidateStatus;
    this.copyTimeSlots = this.timeSlots;

    this.eventCategory =
      window.localStorage.getItem('eventCategory') || 'technical';

    const actionButtons = ['Move Stage', 'Send Email', 'Send Test Link', 'Send Interview Link',
      'Send Documentation Link', 'Send Offer', 'Send Interview Venue'];
    this.changeStatusOptions = (this.stage?.actions || [])
      .filter((action: any) => !actionButtons.includes(action.name))
      .map((action: any) => ({ ...action, isSelected: false }));
  }
  ngOnDestroy(): void {
    this.instituteSearch$.next();
    this.instituteSearch$.complete();
  }
  onYearSelected(event: Date) {
    const selectedYear = moment(event).year().toString();
    this.filterUpdate(selectedYear, 'graduationYear');
  }

  generateTimeSlots() {
    const slots = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 5) {
        const hourStr = hour.toString().padStart(2, '0');
        const minuteStr = minute.toString().padStart(2, '0');
        const value = `${hourStr}:${minuteStr}`;
        
        // 12-hour format for display
        let displayHour = hour % 12;
        if (displayHour === 0) displayHour = 12;
        const ampm = hour < 12 ? 'AM' : 'PM';
        const formattedTime = `${displayHour.toString().padStart(2, '0')}:${minuteStr} ${ampm}`;
        
        slots.push({
          hour: hourStr,
          minute: minuteStr,
          value: value,
          formattedTime: formattedTime
        });
      }
    }
    return slots;
  }

  generateDurationSlots() {
    const slots = [];
    for (let minutes = 15; minutes <= 300; minutes += 15) {
      slots.push({
        label: `${Math.floor(minutes/60)}h ${minutes%60}m`,
        value: minutes
      });
    }
    return slots;
  }

  getDurationSlots() {
    if (this.stage?.type === 'AI Interview') {
      return [
        {label: '0h 5m', value: 5},
        {label: '0h 10m', value: 10},
        {label: '0h 15m', value: 15},
        {label: '0h 20m', value: 20},
        {label: '0h 25m', value: 25},
        {label: '0h 30m', value: 30},
        {label: '0h 35m', value: 35},
        {label: '0h 40m', value: 40},
        {label: '0h 45m', value: 45},
        {label: '0h 50m', value: 50},
        {label: '0h 55m', value: 55},
        {label: '1h 0m', value: 60}
      ];
    }
    return this.durationSlots;
  }

  validateEndTime() {
    const startDate = this.sendLinkForm.get('interviewDate')?.value ;
    const startTime = this.sendLinkForm.get('startTime')?.value;
    const duration = this.sendLinkForm.get('duration')?.value;

    if (startDate && startTime && duration) {
      const startDateTime = new Date(startDate);
      const [hours, minutes] = startTime.split(':');
      startDateTime.setHours(parseInt(hours), parseInt(minutes));
      
      const endDateTime = new Date(startDateTime.getTime() + duration * 60000);
      const maxEndTime = new Date(startDateTime.getTime() + 180 * 60000); // 3 hours

      return endDateTime <= maxEndTime;
    }
    return true;
  }

  public getStatusColor(status: candidateStatus | string | { name: string }): string {
    const statusName = typeof status === 'string' ? status : status?.name;
    return statusColorMapping[statusName as candidateStatus] || 'transparent';
  }

  getStageTypeClass(type: string): string {
    const typeClassMap: { [key: string]: string } = {
      'Assessment': 'tag-test',
      'Online Interview': 'tag-interview',
      'Offline Interview': 'tag-offline-interview',
      'Documentation': 'tag-screening',
      'Offer': 'tag-offer',
      'OnBoarding': 'tag-onboarding',
      'Registration': 'tag-eligibility',
      'AI Interview': 'tag-ai-interview'
    };
    return typeClassMap[type] || 'tag-default';
  }

  getStatusTextClass(statusName: string): string {
    const statusClassMap: { [key: string]: string } = {
      'Pending': 'status-pending',
      'Shortlist': 'status-shortlist',
      'Rejected': 'status-rejected',
      'Waitlist': 'status-waitlist',
      'Not Eligible': 'status-not-eligible',
      'Eligible': 'status-eligible',
      'Joining Confirmed': 'status-joining-confirmed',
      'Not Joining': 'status-not-joining',
      'Slot Sent': 'status-slot-sent',
      'Completed': 'status-completed-text',
      'No Show': 'status-no-show',
      'Cancelled': 'status-cancelled',
      // Documentation statuses
      'Mail Pending': 'status-mail-pending',
      'Submission Pending': 'status-submission-pending',
      'Submitted': 'status-submitted',
      'Submitted Partially': 'status-submitted-partially',
      'Approved Partially': 'status-approved-partially',
      'All Clear': 'status-all-clear',
      // Offer statuses
      'Offer Pending': 'status-offer-pending',
      'On Hold': 'status-on-hold',
      'Future Candidate': 'status-future-candidate',
      'Offered': 'status-offered',
      'Offer Revision': 'status-offer-revision',
      'Offer Accepted': 'status-offer-accepted',
      'Offer Rejected': 'status-offer-rejected',
      // Onboarding statuses
      'Joined': 'status-joined',
      'Not Joined': 'status-not-joined',
      'Yet To Join': 'status-yet-to-join'
    };
    return statusClassMap[statusName] || 'status-default';
  }

  toggleSelectAllCandidates(): void {
    this.selectedAllStageCandidates = !this.selectedAllStageCandidates;
    if (this.selectedAllStageCandidates) {
      this.selectedUsersList = [...this.candidateList];
    }
  }

  ngOnChanges(): void {
    // Re-apply when a fresh deep-link status arrives (component reused across redirects).
    const reloaded = this.applyDeepLinkStatus(true);
    if (!reloaded && this.search?.length) this.getCandidates();
    if (this.emailsCleared) {
      this.selectedUsersList = [];
    }
  }

  private applyDeepLinkStatus(reload: boolean): boolean {
    if (!this.initialStatus || this.initialStatus === this.appliedStatusFilter) return false;
    if (!this.statusFilterOptions?.length) return false;

    const norm = (s: string) => (s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const target = norm(this.initialStatus);
    const option = this.statusFilterOptions.find((o: any) => norm(o.value) === target);
    if (!option) return false;

    this.filterCriteria = this.filterCriteria.filter((f) => f.filterField !== 'jobStatus');
    this.filterCriteria.push({ filterField: 'jobStatus', filterValue: option.value });
    const statusCol = this._selectedColumns.find((c: any) => c.field === 'status');
    if (statusCol) statusCol.selectedFilterElement = option;
    this.appliedStatusFilter = this.initialStatus;
    if (reload) {
      this.getCandidates();
      return true;
    }
    return false;
  }

  filterInstitute(event: MultiSelectFilterEvent) {
    if(event.filter.length >= 2 || !event.filter.length) {
      this.instituteSearch$.next();
      this.institutionsSearchQuery = event.filter;
      this.hasMoreInstitutions = true;
      this.collegeList = [...this.selectedCollegeList];
      this.institutionsPage = 1;
      this.getInstitutions();
    }
  }

  filterUpdate(filterValue: any, filterField: string) {
    if (filterField == 'status') filterField = 'jobStatus';
    const i = this.filterCriteria.findIndex(e => e.filterField === filterField) ?? null;

    if (this.filterCriteria.length && (i >= 0)) {
      this.filterCriteria[i] = { filterField: filterField, filterValue: filterValue };
    } else {
      this.filterCriteria.push({ filterField: filterField, filterValue: filterValue });
    }
    this.filterCriteria = this.filterCriteria.filter((field: FilterCriteria) => 
      field.filterValue != '' && 
      !(Array.isArray(field.filterValue) && field.filterValue.length === 0)
    );

    if(filterField === "collegeName") {
      const foundColleges = filterValue
          .map((val: any) => this.collegeList.find((college: any) => college.value === val))
          .filter(Boolean); // remove null/undefined if not found

        this.selectedCollegeList = this.selectedCollegeList.filter((clg) => filterValue.includes(clg.value));
        this.selectedCollegeList = [
          ...this.selectedCollegeList,
          ...foundColleges.filter(
            (newItem: any) => !this.selectedCollegeList.some(c => c?.value === newItem?.value)
          )
        ];
    }
    // this.getCandidates();
  }

  filterHide() {
    this.filterLoading = false;
    this.showFilterSidebar = false;
    // this.activeTabIndex = [];
  }

  applySelectedFilter = () => {
    // this.activeTabIndex = [];
    this.pageNumber = 1;
    this.first = 1;
    this.filterLoading = true;
    this.filterApplied = true;
    this.selectedUsersList = [];
    this.selectedAllStageCandidates = false;
    this.getCandidates();
    this.takeFilterBackup();
    this.showFilterSidebar = false;
  };

  dateFilter() {
    if (this.rangeDates?.includes(null)) {
      this.messageService.add({ severity: 'error', summary: 'Try Again!', detail: 'Select End Range for Filter !' })
    } else {
      let payload: any = {
        joinedDateRange: {}
      }
      if (this.rangeDates?.length == 2) {
        if (this.rangeDates[0]) {
          if (this.rangeDates[1]) {
            this.rangeDates[0].setHours(this.rangeDates[0].getHours() + 5);
            this.rangeDates[0].setMinutes(this.rangeDates[0].getMinutes() + 30);
            this.rangeDates[1].setHours(this.rangeDates[1].getHours() + 5);
            this.rangeDates[1].setMinutes(this.rangeDates[1].getMinutes() + 30);
          }
        }

        let startDate = this.rangeDates[0] ? new Date(this.rangeDates[0]).toISOString() : '';
        
        let endDate = this.rangeDates[1] ? new Date(this.rangeDates[1]).toISOString() : '';

        payload.joinedDateRange = {
          joiningDateStart: startDate,
          joiningDateEnd: endDate
        }
      }
      return payload;
    }
  }
  onSlide(event: any) {
    const [startValue, endValue] = this.testRange;

    if (event.handleIndex === 0 && event.value >= endValue) {
      this.testRange = [endValue, endValue];
    } else if (event.handleIndex === 1 && event.value <= startValue) {
      this.testRange = [startValue, startValue];
    } else {
      this.testRange = [event.values[0], event.values[1]];
    }
    
    this.firstValue = this.testRange[0];
    this.secondValue = this.testRange[1];
  }

  applyFilter() {
    if (this.assessmentRange.includes(null) || this.contestValidityRange.includes(null) || this.testRange.length < 2) {
      this.messageService.add({ severity: 'error', summary: 'Try Again!', detail: 'Select End Range for Filter !' })
    } else {
      let payload: any = {
        companyId: this.companyId,
        jobId: this.jobId,
        stageId: this.stage.id,
        stageNumber: this.stage.stageId,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        filterCriteria: {}
      };

      if(this.firstValue >= 0 && this.secondValue >= 0){
          payload.percentageFilter = {
            fromPercent : this.firstValue,
            toPercent : this.secondValue
          }
      }
      
      if (this.contestValidityRange.length == 2) {
        payload.contestValidity = {
          contestStartTime: this.contestValidityRange[0],
          contestEndTime: this.contestValidityRange[1]
        }
      }
      if (this.assessmentRange.length == 2) {
        this.assessmentRange[0].setHours(this.assessmentRange[0].getHours() + 5);
        this.assessmentRange[0].setMinutes(this.assessmentRange[0].getMinutes() + 30);
        this.assessmentRange[1].setHours(this.assessmentRange[1].getHours() + 29);
        this.assessmentRange[1].setMinutes(this.assessmentRange[1].getMinutes() + 29);
        payload.filterCriteria.testStartTime = [
          {
            fieldPath: "starttime",
            operator: ">=",
            fieldValue: this.assessmentRange[0]
          },
          {
            fieldPath: "starttime",
            operator: "<=",
            fieldValue: this.assessmentRange[1]
          }
        ];
      }
      return payload;
    }
  }


  filterShow() {
    // this.activeTabIndex = -1;
    this.loadDynamicFilterFields();
    this.takeFilterBackup();

    this.hasMoreInstitutions = true;
    this.collegeList = [...this.selectedCollegeList];
    this.institutionsPage = 1;
  }

  async loadDynamicFilterFields() {
    try {      
      const sharedService = this.globalService.getSharedService()
      let eventDetails = sharedService.getEventDetails(this.eventId);
      
      if (!eventDetails?.event_details?.form?.uuid) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'No registration form found for this event. Using default filter options.'
        });
        return;
      }

      this.registrationFormId = eventDetails.event_details.form.uuid;

      const formResponse = await firstValueFrom(
        sharedService.initiateFormRequest(this.eventId, () => 
          this.formBuilderService.getFormFastApi(this.registrationFormId)
        ) || this.formBuilderService.getFormFastApi(this.registrationFormId)
      );

      if (formResponse?.body?.form_fields) {
        this.registrationFormFields = this.extractFormFields(formResponse.body.form_fields);
        this.mapDefaultFiltersToFormFields();
        await this.loadFormDataWithFields(formResponse.body.form_fields);
        this.mapDefaultFiltersToFormFields();
      } else {
        await this.loadFormDataFallback();
      }
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load filter options. Using default options.'
      });
    }
  }

  async loadFormDataWithFields(formFields: any[]) {
    try {
      const lookupData = await this.fieldLookupService.loadOptimizedLookupData(this.eventId, formFields);
      
      // Process roles and locations
      if (lookupData.roles) {
        const roles = lookupData.roles || [];
        const uniqueLocations = new Set<string>();
        this.preferredLocations = [];
        this.jobRoles = [];
        
        roles.forEach((role: any) => {
          if (role.preferred_location && Array.isArray(role.preferred_location)) {
            role.preferred_location.forEach((location: string) => {
              uniqueLocations.add(location);
            });
          }
          this.jobRoles.push({
            label: role.job_role_name,
            value: String(role.job_role_id)
          });
        });
        this.preferredLocations = Array.from(uniqueLocations).map(location => ({
          label: location,
          value: location
        }));
      }
      
      // Load lookup data
      this.instituteList = lookupData.institutes.items || [];
      this.certificateList = lookupData.certifications || [];
      this.languagesList = lookupData.languages || [];
      this.skillsList = lookupData.skills || [];
      this.sscBoardsList = lookupData.ssc_boards || [];
      this.intermediateBoardsList = lookupData.intermediate_boards || [];
      this.entranceTestsList = lookupData.entrance_tests || [];
      this.educationBranchesList = lookupData.education_branches || [];
      this.educationDegreesList = lookupData.education_degrees || [];
      
    } catch (error) {
      console.error('Error loading form data:', error);
    }
  }

  // Fallback method - only used when form fields are not available
  private async loadFormDataFallback() {
    try {
      const sharedService = this.globalService.getSharedService()
      const commonData = sharedService.getCommonLookupData();
      
      const hasCommonData = commonData && Object.keys(commonData).length > 0;
      
      // If no cached data, request all lookup data as fallback
      const lookupFlags = hasCommonData ? {
        includeRoles: true,
        includeInstitutes: false,
        includeCertifications: false,
        includeLanguages: false,
        includeSkills: false,
        includeSscBoards: false,
        includeIntermediateBoards: false,
        includeEntranceTests: false,
        includeEducationDegrees: false,
        includeEducationBranches: false
      } : {
        includeRoles: true,
        includeInstitutes: true,
        includeCertifications: true,
        includeLanguages: true,
        includeSkills: true,
        includeSscBoards: true,
        includeIntermediateBoards: true,
        includeEntranceTests: true,
        includeEducationDegrees: true,
        includeEducationBranches: true
      };
      
      const roleResponse = await firstValueFrom(
        sharedService.initiateFormDetailsRequest(this.eventId, () => 
          this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, lookupFlags)
        ) || this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, lookupFlags)
      );

      const apiData = roleResponse?.body || roleResponse;
      
      if (apiData?.roles) {
        const roles = apiData.roles || [];
        const uniqueLocations = new Set<string>();
        this.preferredLocations = [];
        this.jobRoles = [];
        
        roles.forEach((role: any) => {
          if (role.preferred_location && Array.isArray(role.preferred_location)) {
            role.preferred_location.forEach((location: string) => {
              uniqueLocations.add(location);
            });
          }
          this.jobRoles.push({
            label: role.job_role_name,
            value: String(role.job_role_id)
          });
        });
        this.preferredLocations = Array.from(uniqueLocations).map(location => ({
          label: location,
          value: location
        }));
      }
      
      // Extract and cache common data if not already cached
      if (!hasCommonData && apiData) {
        const extractedCommonData = {
          institutes: apiData.institutes || [],
          certifications: apiData.certifications || [],
          languages: apiData.languages || [],
          skills: apiData.skills || [],
          ssc_boards: apiData.ssc_boards || [],
          intermediate_boards: apiData.intermediate_boards || [],
          entrance_tests: apiData.entrance_tests || [],
          education_branches: apiData.education_branches || [],
          education_degrees: apiData.education_degrees || []
        };
        sharedService.setCommonLookupData(extractedCommonData);
      }
      
      // Load lookup data from cache or API
      this.instituteList = commonData?.institutes || apiData.institutes || [];
      this.certificateList = commonData?.certifications || apiData.certifications || [];
      this.languagesList = commonData?.languages || apiData.languages || [];
      this.skillsList = commonData?.skills || apiData.skills || [];
      this.sscBoardsList = commonData?.ssc_boards || apiData.ssc_boards || [];
      this.intermediateBoardsList = commonData?.intermediate_boards || apiData.intermediate_boards || [];
      this.entranceTestsList = commonData?.entrance_tests || apiData.entrance_tests || [];
      this.educationBranchesList = commonData?.education_branches || apiData.education_branches || [];
      this.educationDegreesList = commonData?.education_degrees || apiData.education_degrees || [];
      
    } catch (error) {
      console.error('Error loading form data:', error);
    }
  }

  setDefaultFilterOptions() {
    if (this.jobRoles.length > 0) {
      this.roleList = this.jobRoles;
    }
    
    if (this.instituteList.length > 0) {
      this.collegeList = this.instituteList.map((institute: any) => ({
        label: `${institute.name}, ${institute.city}, ${institute.state}`,
        value: `${institute.name}, ${institute.city}, ${institute.state}`,
      }));
    }
    
    if (!this.genderList || this.genderList.length === 0) {
      this.genderList = [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Prefer not to say", value: "others" }
      ];
    }
    
    if (!this.arrearList || this.arrearList.length === 0) {
      this.arrearList = [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ];
    }
    
    if (!this.pwdList || this.pwdList.length === 0) {
      this.pwdList = [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
        { label: "Do not wish to disclose", value: "Do not wish to disclose" },
        { label: "Not yet filled", value: "Not Yet Filled" }
      ];
    }
    
    if (!this.branchList || this.branchList.length === 0) {
      this.branchList = [
        { label: "Computer Science", value: "Computer Science" },
        { label: "Information Technology", value: "Information Technology" },
        { label: "Electronics & Communication", value: "Electronics & Communication" },
        { label: "Electrical Engineering", value: "Electrical Engineering" },
        { label: "Mechanical Engineering", value: "Mechanical Engineering" },
        { label: "Civil Engineering", value: "Civil Engineering" },
        { label: "Chemical Engineering", value: "Chemical Engineering" },
        { label: "Other", value: "Other" }
      ];
    }
  }

  extractFormFields(formFields: any[]): any[] {
    const extractedFields: any[] = [];
    
    formFields.forEach((section: any) => {
      if (section.section_form_fields) {
        section.section_form_fields.forEach((field: any) => {
          if (field.element_type === 'field') {
            extractedFields.push({
              name: field.name,
              label: field.label || field.name,
              type: field.type,
              options: field.options || [],
              is_required: field.is_required,
              placeholder: field.placeholder,
              section: section.name
            });
          } else if (field.element_type === 'group' && field.form_fields) {
            field.form_fields.forEach((groupField: any) => {
              extractedFields.push({
                name: groupField.name,
                label: groupField.label || groupField.name,
                type: groupField.type,
                options: groupField.options || [],
                is_required: groupField.is_required,
                placeholder: groupField.placeholder,
                section: section.name,
                group: field.name
              });
            });
          }
        });
      }
    });

    return extractedFields;
  }

  mapDefaultFiltersToFormFields() {
    this.filterFieldVisibility = {
      isPWD: false,
      jobRole: false,
      arrears: false,
      gender: false,
      graduationYear: false,
      degreeBranch: false,
      degree: false,
      collegeName: false
    };
    
    this.filterFieldTypes = {
      isPWD: 'dropdown',
      jobRole: 'dropdown',
      arrears: 'dropdown',
      gender: 'dropdown',
      graduationYear: 'date',
      degreeBranch: 'dropdown',
      degree: 'dropdown',
      collegeName: 'dropdown'
    };

    this.registrationFormFields.forEach((field: any) => {
      const fieldName = field.name.toLowerCase();
      
      if (fieldName.includes('pwd') || fieldName.includes('disability') || fieldName.includes('differently_abled')) {
        this.filterFieldVisibility['isPWD'] = true;
        if (field.type === 'input' || field.type === 'Input') {
          this.filterFieldTypes['isPWD'] = 'input';
        }
        this.setFieldOptions(field, 'pwdList');
      }
      
      if (fieldName.includes('preferred_role') || fieldName.includes('job_role') || fieldName.includes('role')) {
        this.filterFieldVisibility['jobRole'] = true;
        if (field.type === 'input' || field.type === 'Input') {
          this.filterFieldTypes['jobRole'] = 'input';
        }
        this.setFieldOptions(field, 'roleList');
      }
      
      if (fieldName.includes('arrears') || fieldName.includes('backlog') || fieldName.includes('standing_backlog')) {
        this.filterFieldVisibility['arrears'] = true;
        if (field.type === 'input' || field.type === 'Input') {
          this.filterFieldTypes['arrears'] = 'input';
        }
        this.setFieldOptions(field, 'arrearList');
      }
      
      if (fieldName.includes('gender') || fieldName.includes('sex')) {
        this.filterFieldVisibility['gender'] = true;
        if (field.type === 'input' || field.type === 'Input') {
          this.filterFieldTypes['gender'] = 'input';
        }
        this.setFieldOptions(field, 'genderList');
      }
      
      if (fieldName.includes('graduation_year') || fieldName.includes('end_date') || fieldName.includes('completion_year')) {
        this.filterFieldVisibility['graduationYear'] = true;
        this.filterFieldTypes['graduationYear'] = 'date';
      }
      
      if (['ug_degree', 'pg_degree', 'diploma_degree'].includes(fieldName)) {
        this.filterFieldVisibility['degree'] = true;
        if (field.type === 'input' || field.type === 'Input') {
          this.filterFieldTypes['degree'] = 'input';
        }
        this.setFieldOptions(field, 'degreeList');
      }
      
      if (['ug_specialization', 'pg_specialization', 'diploma_specialization'].includes(fieldName)) {
        this.filterFieldVisibility['degreeBranch'] = true;
        if (field.type === 'input' || field.type === 'Input') {
          this.filterFieldTypes['degreeBranch'] = 'input';
        }
        this.setFieldOptions(field, 'branchList');
      }
      
      if (fieldName.includes('college_name') || fieldName.includes('institute')) {
        this.filterFieldVisibility['collegeName'] = true;
        if (field.type === 'input' || field.type === 'Input') {
          this.filterFieldTypes['collegeName'] = 'input';
        }
        this.setFieldOptions(field, 'collegeList');
      }
    });
  }

  setFieldOptions(field: any, filterListName: string) {
    const appendToFilterList = (targetList: any[], newOptions: any[]) => {
      if (!newOptions || newOptions.length === 0) return targetList;
      
      const existingOptions = targetList || [];
      const validNewOptions = newOptions.filter((option: any) => 
        option && option.label && option.label.trim() !== '' && 
        option.value && option.value.trim() !== '' &&
        !existingOptions.some((existing: any) => existing.value === option.value)
      );
      
      return [...existingOptions, ...validNewOptions];
    };

    switch (filterListName) {
      case 'pwdList':
        if (field.options && field.options.length > 0) {
          this.pwdList = appendToFilterList(this.pwdList, field.options);
        }
        break;
      
      case 'roleList':
        if (this.jobRoles.length > 0) {
          this.roleList = this.jobRoles;
        } else if (field.options && field.options.length > 0) {
          this.roleList = appendToFilterList(this.roleList, field.options);
        }
        break;
      
      case 'arrearList':
        if (field.options && field.options.length > 0) {
          this.arrearList = appendToFilterList(this.arrearList, field.options);
        }
        break;
      
      case 'genderList':
        if (field.options && field.options.length > 0) {
          this.genderList = appendToFilterList(this.genderList, field.options);
        }
        break;
      
      case 'degreeList':
        if (this.educationDegreesList && this.educationDegreesList.length > 0) {
          const degreeOptions = this.educationDegreesList
            .filter((degree: any) => String(degree?.name ?? '').toLowerCase() !== 'others')
            .map((degree: any) => ({
              label: degree.name,
              value: degree.name,
            }));
          this.degreeList = appendToFilterList(this.degreeList, degreeOptions);
        }
        if (field.options && field.options.length > 0) {
          this.degreeList = appendToFilterList(this.degreeList, field.options);
        }
        break;
      
      case 'branchList':
        if (this.educationBranchesList && this.educationBranchesList.length > 0) {
          const branchOptions = this.educationBranchesList
            .filter((branch: any) => String(branch?.name ?? '').toLowerCase() !== 'others')
            .map((branch: any) => ({
              label: branch.name,
              value: branch.name,
            }));
          this.branchList = appendToFilterList(this.branchList, branchOptions);
        }
        if (field.options && field.options.length > 0) {
          this.branchList = appendToFilterList(this.branchList, field.options);
        }
        break;
      
      case 'collegeList':
        if (this.instituteList && this.instituteList.length > 0) {
          const instituteOptions = this.instituteList.map((institute: any) => ({
            label: `${institute.name}, ${institute.city}, ${institute.state}`,
            value: `${institute.name}, ${institute.city}, ${institute.state}`,
          }));
          this.collegeList = appendToFilterList(this.collegeList, instituteOptions);
        }        
        if (field.options && field.options.length > 0) {
          const formOptions = field.options.map((option: any) => ({
            label: option.label,
            value: option.label 
          }));
          this.collegeList = appendToFilterList(this.collegeList, formOptions);
        }
        break;
      
      default:
        break;
    }
  }

  mapFieldOptions(fieldName: string, list: any[], labelKey: any = [], valueKey: string): any[] {
    return list.map(item => ({
      label: labelKey.map((key: string | number) => item[key]).join(', '),
      value: item[valueKey]
    }));
  }

  clearSelectedFilters = () => {
    this.pageNumber = 1;
    this.first = 1;
    this.filterLoading = false;
    this.filterCriteria = [];
    this.filterCount = 0;
    this.testRange = [0,100];
    this.firstValue = undefined;
    this.secondValue = undefined;
    this.assessmentRange = [new Date()];
    this.contestValidityRange = [new Date()];
    this.rangeDates = [new Date()];
    this.selectedBranch = [];
    this.selectedDegree = [];
    this.selectedCollege = [];
    this.selectedSpecial = [];
    this.selectedRole = [];
    this.selectedArrears = null;
    this.selectedPwd = null;
    this.selectedGender = null;
    this.selectedEligibility = '';
    this.selectedYearDate = null;
    this.showFilterSidebar = false;
    
    this.selectedPwdText = '';
    this.selectedRoleText = '';
    this.selectedArrearsText = '';
    this.selectedGenderText = '';
    this.selectedBranchText = '';
    this.selectedDegreeText = '';
    this.selectedCollegeText = '';
    
    this._selectedColumns.forEach(each => {
      if (each.options) each.selectedFilterElement = { label: 'All', value: '' }
    })
    this.getCandidates();

    this.activeTabIndex = [0]
    this.filterBackup = {};
    this.selectedCollegeList = [];
  }

  handleSelection = (event: any) => {
    if(this.selectedUsersList.length < this.last){
      this.selectedAllStageCandidates = false;
    }
    this.emails = event.map((user: any) => user.email);
    if (this.stage.type == 'Offer') {
      let cohortEmails = event.map((user: any) => user.email);
      this.emailList.emit(cohortEmails);
    }
  };

  addColumns = () => {
    let testCompletedStage: Array<any> = [];
    if (this.stages && Array.isArray(this.stages)) {
      const currentStageIndex = this.stages.findIndex(
        (s: any) => s.id === this.stage.id || s.stageId === this.stage.stageId
      );
      testCompletedStage = this.stages.filter((stage: any, index: number) =>
        stage.type === 'Assessment' && currentStageIndex >= index
      );
    }
    this.candidatesCol = this.candidatesCol.filter(col => col.field !== 'testScore');
    this._selectedColumns = this._selectedColumns.filter(col => col.field !== 'testScore');
    const statusIndex = this.candidatesCol.findIndex(col => col.field === 'status');

    testCompletedStage.forEach(stage => {
      this.candidatesCol.splice(statusIndex + 1, 0, {
        index: statusIndex + 1,
        field: 'testScore',
        stageId: stage.id,
        header: this.stage.stageId === stage.id ? "Score" : stage.name + '(Score)',
        testSchedule: stage.scheduleTest,
        sortable: true,
      });
      if (stage.id === this.stage.id) {
        this._selectedColumns.splice(statusIndex + 1, 0, {
          index: statusIndex + 1,
          field: 'testScore',
          stageId: stage.id,
          header: this.stage.stageId === stage.id ? "Score" :  stage.name + '(Score)',
          testSchedule: stage.scheduleTest,
          sortable: true,
        });
      }
    });

    if (this.stage.type == 'Assessment') {
      this._selectedColumns = this._selectedColumns.filter(
        col => !['collegeName', 'gender', 'dob'].includes(col.field)
      );
      this.candidatesCol.push({
        index: 1,
        field: 'testStartTime',
        header: 'Assessment Started Time',
        date: true
      }, {
        index: 1,
        field: 'testSubmitTime',
        header: 'Assessment Submitted Time',
        date: true
      }, {
        index: 1,
        field: 'contestStartTime',
        header: 'Course Start Time',
        date: true
      }, {
        index: 1,
        field: 'contestEndTime',
        header: 'Course End Time',
        date: true
      });
      this._selectedColumns.push({
        index: 1,
        field: 'testStartTime',
        header: 'Assessment Started Time',
        date: true
      }, {
        index: 1,
        field: 'testSubmitTime',
        header: 'Assessment Submitted Time',
        date: true
      }, {
        index: 1,
        field: 'contestStartTime',
        header: 'Course Start Time',
        date: true
      }, {
        index: 1,
        field: 'contestEndTime',
        header: 'Course End Time',
        date: true
      });
    }

    if (this.stage.type == 'Registration') {
      this.candidatesCol.splice(6, 0,
        ({ index: 7, field: 'registeredAt', header: 'Registered At' })
      );
      this._selectedColumns.splice(6, 0,
        // ({ index: 7, field: 'registeredAt', header: 'Registered At' })
      );
    }

    if (this.stage.type == 'Documentation') {
      this.candidatesCol.splice(6, 0,
        ({ index: 7, field: 'documentPOC', header: 'Document POC' }),
        ({ index: 8, field: 'isDocumentsSubmitted', header: 'Document', }),
        ({ index: 9, field: 'jobRole', header: 'Job Role' }),
        ({ index: 10, field: 'documentationCreatedAt', header: 'Document Sent at' }),
        ({ index: 11, field: 'documentationDeadline', header: 'Deadline' }),
        ({ index: 12, field: 'documentSubmittedAt', header: 'Document Submitted at' })
      );
      this._selectedColumns.splice(6, 0,
        ({ index: 7, field: 'documentPOC', header: 'Document POC' }),
        ({ index: 8, field: 'isDocumentsSubmitted', header: 'Document' }),
        ({ index: 9, field: 'jobRole', header: 'Job Role' }),
        ({ index: 10, field: 'documentationCreatedAt', header: 'Document Sent at' }),
        ({ index: 11, field: 'documentationDeadline', header: 'Deadline' }),
        ({ index: 12, field: 'documentSubmittedAt', header: 'Document Submitted at' })
      );
    }


    if (this.stage.type == 'Online Interview' || this.stage.type == 'Offline Interview') {
      this.candidatesCol.splice(2, 0,
        ({ index: 3, field: 'feedbackStatus', header: 'Feedback Status' }),
        ({ index: 4, field: 'jobRole', header: 'Job Role' }),
        ({ index: 5, field: 'interviewStartAt', header: 'Interview Start Time' })
      );
      this._selectedColumns.splice(2, 0, 
        ({ index: 3, field: 'feedbackStatus', header: 'Feedback Status' }),
        ({ index: 4, field: 'jobRole', header: 'Job Role' }),
        ({ index: 5, field: 'interviewStartAt', header: 'Interview Start Time' })
      );
      this.stageType = this.stage.type;
    }

    if (this.stage.type == 'Offer') {
      this.candidatesCol.splice(4, 0,
        // ({ index: 7, field: 'offerPOC', header: 'Offer POC' }),
        ({ index: 8, field: 'offerResponse', header: 'Offer Response' }),
        ({ index: 9, field: 'declinedRemarks', header: 'Reason for Declining' }),
        ({ index: 10, field: 'jobRole', header: 'Job Role' }),
        ({ index: 11, field: 'offerSentAt', header: 'Offer Sent at' }),
        ({ index: 12, field: 'offerDeadline', header: 'Offer Deadline' }),
        ({ index: 13, field: 'offerSubmittedAt', header: 'Offer Submitted at' })
      );
      this._selectedColumns.splice(4, 0,
        // ({ index: 7, field: 'offerPOC', header: 'Offer POC' }),
        ({ index: 8, field: 'offerResponse', header: 'Offer Response' }),
        ({ index: 9, field: 'declinedRemarks', header: 'Reason for Declining' }),
        ({ index: 10, field: 'jobRole', header: 'Job Role' }),
        ({ index: 11, field: 'offerSentAt', header: 'Offer Sent at' }),
        ({ index: 12, field: 'offerDeadline', header: 'Offer Deadline' }),
        ({ index: 13, field: 'offerSubmittedAt', header: 'Offer Submitted at' })
      );
    }

    if (this.stage.type == 'Onboarding') {
      this.candidatesCol.splice(4, 0,
        ({ index: 8, field: 'offerResponse', header: 'Offer Response' }),
        ({ index: 10, field: 'offerLocations', header: 'Offer Locations' }),
      );
      this._selectedColumns.splice(4, 0,
        ({ index: 8, field: 'offerResponse', header: 'Offer Response' }),
        ({ index: 10, field: 'offerLocations', header: 'Offer Locations' }),
      );
    }
    if (this.stage.type == 'Others') {
      this.stageType = this.stage.type;
    }

    if (this.stage.type == 'OnBoarding') {
      this.candidatesCol.splice(2, 0, ({ index: 3, field: 'joiningDate', header: 'Joining Date' }));
      this._selectedColumns.splice(2, 0, ({ index: 3, field: 'joiningDate', header: 'Joining Date' }));
      this.stageType = this.stage.type;
    }
  };

  templateDownload() {
    let type = this.scheduleRadio;
    this.eventServices.sendInterviewLinkSampleExportFastApi(this.eventId, this.stage.stageId, type).subscribe({
      next: (response: HttpResponse<Blob>) => {
        this.loadingDownload = false;
        const fileName = `Bulk_Interview_Schedule_Template_${type}_${this.stage.name}`;

        if (!response.body) {
          throw new Error('Response body is empty');
        }
        const blob = new Blob([response.body], { type: response.body.type });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Access denied. You do not have permission to download this file.'
          });
        } else if (error.status === 500) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Internal server error. Please try again later.'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'An unexpected error occurred. Please try again later.'
          });
        }
        this.loadingDownload = false;
      }
    });
  }

  uploadTemplate(event: any) {
    this.template = event.addedFiles;
    this.templateUploaded = true;
    this.templateLoader = true;
    this.fileCopy = this.template[0];

    if (this.fileCopy.size > 2 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'File size should be less than 2MB'
      });
      return;
    }
    this.templateSize = `${(this.fileCopy.size / 1024).toFixed(2)} KB`;
    const fileName = this.generateFileName(this.fileCopy);
    const filePath = `temp/${this.companyId}/${fileName}`;
    let origin = "stage_import_candidate";
    if (this.showScheduleSlider) {
      origin = "interview_invite";
    }
    if (this.showTestScheduleSlider) {
      origin = "send_test_invite";
    }
    const payload = {
      file_path: filePath,
      bucket_type: 'private',
      origin: origin,
    };

    this.uploadingFile = true;
    this.fileUploadService.getSignedUrlGCS(payload).subscribe({
      next: (response: any) => {
        if (response && response.body.signed_url) {
          this.uploadFileToGCS(response.body.signed_url, this.fileCopy, filePath, fileName);
        }
      },
      error: (error) => {
        console.error('Error getting signed URL:', error);
        this.uploadingFile = false;
      }
    });
  }

  private generateFileName(file: any): string {
    let fileName = file.name.split(".");
    let fileExtension = fileName.pop();
    const timestamp = new Date().getTime();
    return `${fileName.join().replace(/\s/g, "").replace(/[^\w\s]/gi, '')}_${timestamp}.${fileExtension}`;
  }

  uploadFileToGCS(signedUrl: string, file: any, filePath: string, filename: string) {
    this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
      next: (response: any) => {
        if (response && response.status === "success") {
          this.uploadingFile = false;
          if (this.showScheduleSlider) {
            this.interviewFileName = filename;
          } else if (this.showTestScheduleSlider) {
            this.testFileName = filename;
          } else {
            this.interviewFileName = filename;
          }
        }
      },
      error: (error) => {
        this.uploadingFile = false;
      }
    });
  }

  bulkSchedule() {
    this.errorFileUrl = '';
    this.interviewFileName = '';
    this.templateUploaded = false;
    this.scheduleBtnLoading = false;
    this.template = [];
    this.scheduleRadio = 'all';
    this.bulkScheduleSendEmail = true;
    this.remarks='';
  }

  bulkTestSchedule() {
    this.errorFileUrl = '';
    this.testFileName = '';
    this.templateUploaded = false;
    this.testScheduleBtnLoading = false;
    this.template = [];
  }

  downloadErrorReport() {
    if (this.errorFileUrl) {
      window.open(this.errorFileUrl, '_blank');
    }
  }

  scheduleFileUpload() {
    this.scheduleBtnLoading = true;
    this.errorFileUrl = '';
    if (this.template[0] && this.interviewFileName) {
      const payload = {
        file_name: this.interviewFileName,
        send_email_to_candidate: this.bulkScheduleSendEmail,
      };
      this.eventServices.bulkInterviewLinkFastApi(payload, this.eventId, this.stage.stageId).subscribe({
        next: (response: any) => {
          this.bulkSchedule();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail
          });
          this.showScheduleSlider = false;
        },
        error: (error: HttpErrorResponse) => {
          const errorResponse = error.error as InterviewBulkSchedule;
          this.bulkSchedule();
          if (errorResponse.error_file) {
            this.errorFileUrl = errorResponse.error_file;
            this.messageService.add({
              severity: 'warn',
              summary: 'Warning',
              detail: 'Some records have errors. Please check the error report.'
            });
            return;
          }
  
          if (errorResponse.detail === "File not found") {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'File not found. Please try uploading again.'
            });
            return;
          }

          let errorMessage = 'Something went wrong.';
          if (Array.isArray(errorResponse.detail)) {
            errorMessage = errorResponse.detail[0]?.msg || errorResponse.detail[0]?.ctx?.error || 'Something went wrong.';
          } else if (typeof errorResponse.detail === 'string') {
            errorMessage = errorResponse.detail;
          }

          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: errorMessage
          });
        }
      });

    } else {
      this.scheduleBtnLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to Submit',
      });
    }
  }

  testScheduleFileUpload() {
    this.testScheduleBtnLoading = true;
    this.errorFileUrl = '';
    if (this.template[0] && this.testFileName) {
      const payload = {
        file_name: this.testFileName
      };
      this.eventServices.bulkTestLinkFastApi(payload, this.eventId, this.stage.stageId).subscribe({
        next: (response: any) => {
          this.bulkTestSchedule();
          this.showTestScheduleSlider = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail
          });
        },
        error: (error: HttpErrorResponse) => {
          const errorResponse = error.error as InterviewBulkSchedule;
          this.bulkTestSchedule();
          if (errorResponse.error_file) {
            this.errorFileUrl = errorResponse.error_file;
            this.messageService.add({
              severity: 'warn',
              summary: 'Warning',
              detail: 'Some records have errors. Please check the error report.'
            });
            return;
          }
  
          if (errorResponse.detail === "File not found") {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'File not found. Please try uploading again.'
            });
            return;
          }

          let errorMessage = 'Something went wrong.';
          if (Array.isArray(errorResponse.detail)) {
            errorMessage = errorResponse.detail[0]?.msg || errorResponse.detail[0]?.ctx?.error || 'Something went wrong.';
          } else if (typeof errorResponse.detail === 'string') {
            errorMessage = errorResponse.detail;
          }

          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: errorMessage
          });
        }
      });
    } else {
      this.testScheduleBtnLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to Submit',
      });
    }
  }

  onRemoveExcel() {
    this.template = [];
    this.templateUploaded = false;
    this.templateSize = '';
    this.interviewFileName = '';
    this.testFileName = '';
    this.errorFileUrl = '';
  }
  downloadSampleTemplate(){
    this.eventServices.sendCandidateMoveStageTemplateFastApi(this.eventId, this.stage.stageId).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          const blob = new Blob([res.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let filename = 'Move Candidate Template.xlsx';
          saveAs(blob, filename);
        }
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to download the template. Please try again later.'
        });
      }
    });
  }

  uploadCandidates = (stageId: string) => {
    this.scheduleBtnLoading = true;
    this.errorFileUrl = '';
    if (this.template[0] && this.interviewFileName) {
      const payload = {
        file_name: this.interviewFileName,
        remarks: this.remarks,
      };
      this.eventServices.bulkCandidateMoveStageFastApi(payload, this.eventId, stageId).subscribe({
        next: (response: any) => {
          this.bulkSchedule();
          this.showUploadSlider = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail
          });
        },
        error: (error: HttpErrorResponse) => {
          const errorResponse = error.error as any;
          this.bulkSchedule();
          if (errorResponse.error_file) {
            this.errorFileUrl = errorResponse.error_file;
            this.messageService.add({
              severity: 'warn',
              summary: 'Warning',
              detail: 'Some records have errors. Please check the error report.'
            });
            return;
          }
  
          let errorMessage = 'Something went wrong.';
          
          if (errorResponse.detail) {
            if (Array.isArray(errorResponse.detail) && errorResponse.detail.length > 0) {
              const firstError = errorResponse.detail[0];
              errorMessage = firstError.msg || firstError.message || JSON.stringify(firstError);
            } else if (typeof errorResponse.detail === 'string') {
              errorMessage = errorResponse.detail;
            } else {
              errorMessage = JSON.stringify(errorResponse.detail);
            }
          } else if (errorResponse.message) {
            errorMessage = errorResponse.message;
          }
  
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorMessage
          });
        }
      });

    } else {
      this.scheduleBtnLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to Submit',
      });
    }
  }


  activitySliderSubmit = (options: any) => {
    // console.log('Action Name',options.action,'---',options.toOptions)
    // console.log('Static-->')
    if (options.action == 'moveStage') {
      this.moveCandidates(options.toOptions);
    }
    else if (options.action == 'statusUpdate') {
      this.changeStatus(options.toOptions);
    }
  }

  moveCandidates = async (destinationStage: any) => {
    let destinationStatus = '';
    switch (destinationStage.type) {
      case 'Offer': destinationStatus = 'offerPending'; break;
      case 'Documentation': destinationStatus = 'mailPending'; break;
      default: destinationStatus = 'pending';
    }
    this.uploadBtnLoading = true;
    this.loadingSpinner = true;
    let payload: any = {
      current_stage_uuid: this.stage.stageId,
      move_stage_uuid: destinationStage.stageId,
      candidate_uuids: this.selectedUsersList.map((user: any) => user.id),
      remarks: this.activityRemarks,
    };
    this.eventServices.candidateStageMoveStageFastApi(payload,this.stage.id,this.eventId).subscribe({
      next: (result: any) => {
        if (this.selectedUsersList.length == 1) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: result.body.detail,
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Message',
            detail: 'Bulk process has been initiated. Kindly refresh after some times.'
          });
        }
        this.getCandidates();
        this.selectedUsersList = [];
        this.uploadBtnLoading = false;
        this.activityRemarks = '';
        this.stageActivitySlider = false;
      },
      error: () => {
        this.selectedUsersList = [];
        this.uploadBtnLoading = false;
        this.activityRemarks = '';
        this.stageActivitySlider = false;
      }
    });
  }

  onHideActivity = () => {
    this.stageActivitySlider = false;
    this.resetCheckedColumnsToDefault();
    this.getCandidates();
  }

  moveStageSlider = (stage: any, stageOverlay: any) => {
    this.cohortDetails = stage.type == 'Offer' ? true : false;
    this.activitySliderOptions = {
      header: 'Move Stage',
      action: 'moveStage',
      from: this.stage.name,
      to: stage.name,
      toOptions: stage
    }
    this.stageActivitySlider = true;
    stageOverlay.hide();
  };

  isJobRoleLocationSubmitted() {
    let isValid = true;
    this.selectedUsersList.forEach((user: any) => {
      if (!user?.cohortJobRole || !user?.cohortLocation) {
        isValid = false;
      }
    });
    return isValid;
  }

  changeStatusSlider = (status: any, user?: any) => {

    this.showJoiningDate = status.name;
    if (user) this.selectedUsersList = [user];
    let fromStatus = this.selectedUsersList[0].status;
    this.activitySliderOptions = {
      header: 'Status Update',
      action: 'statusUpdate',
      from: fromStatus,
      to: status.name,
      toOptions: status,
    }
    this.stageActivitySlider = true;
  }

  dateChange() {
    this.sendLinkForm.controls['startTime'].setValue('');
    this.sendLinkForm.controls['duration'].setValue('');
    
    if (this.sendLinkForm.controls['interviewDate'].value.toDateString() === new Date().toDateString()) {
      const currentDate = new Date();
      // currentDate.setMinutes(currentDate.getMinutes() + 15);
      const currentHour = currentDate.getHours().toString().padStart(2, '0');
      const currentMinute = currentDate.getMinutes().toString().padStart(2, '0');
      const currentTime = `${currentHour}:${currentMinute}`;
      this.timeSlots = this.copyTimeSlots.filter((slot: any) => {
        return slot.value > currentTime;
      });
    } else {
      this.timeSlots = this.copyTimeSlots;
    }
  }

  joinDateSelection(date: any) {
    this.selectedJoinDate = date;
  }

  sidenavClosed() {
    this.clicked = false;
    this.sendLinkForm.reset({
      candidates: [],
      interviewDate: null,
      startTime: null,
      duration: null,
      jobRoleId: null,
      venue: null,
      sendEmail: true,
      agentId: null
    });
    this.selectedInterviewers = [];
    this.selectedConferenceProvider = null;
    this.showAvailabilityPanel = false;
    this.availabilityData = [];
    this.timelineScrollOffset = 0;
    this.selectedUsersList = [];
    this.selectedAllStageCandidates = false;
  }

  sendInterviewLink = () => {
    this.clicked = true;
    if (this.sendLinkForm.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill all required fields correctly'
      });
      this.clicked = false;
      return;
    }
    this.uploadBtnLoading = true;
    const formValue = this.sendLinkForm.value;
    const formattedDate = moment(formValue.interviewDate).format('YYYY-MM-DD');
    const formattedTime = moment(formValue.startTime.value, 'HH:mm').format('hh:mm A');
    const formattedDuration = moment.utc()
      .hours(Math.floor(formValue.duration / 60))
      .minutes(formValue.duration % 60)
      .format('HH:mm');
    
    let payload: any = {
      candidate_uuids: this.selectedUsersList.map((user: any) => user.candidate_uuid),
      start_date: formattedDate,
      start_time: formattedTime,
      duration: formattedDuration,
      job_role_id: formValue.jobRoleId
    };

    if (this.stage.type == 'Offline Interview') {
      const venue =  formValue.venue?.trim().replace(/\s+/g, ' ') || '';
      if (!venue) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a valid venue'});
        this.clicked = false;
        this.uploadBtnLoading = false;
        return;
      }
      if (!this.selectedInterviewers || this.selectedInterviewers.length === 0) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select at least one interviewer'});
        this.clicked = false;
        this.uploadBtnLoading = false;
        return;
      }
      payload['interview_mode'] = 'Offline';
      payload['interview_location'] = venue;
      payload['send_email_to_candidate'] = formValue.sendEmail ? true : false;
      payload['interviewers'] = this.selectedInterviewers;
    } else if (this.stage.type === 'AI Interview') {
      payload['interview_mode'] = 'AI';
      payload['agent_id'] = formValue.agentId;
    } else {
      payload['interview_mode'] = 'Online';
      payload['send_email_to_candidate'] = this.isExternalProviderSelected || !!formValue.sendEmail;
      if (!this.selectedConferenceProvider) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select an interview provider'});
        this.clicked = false;
        this.uploadBtnLoading = false;
        return;
      }
      payload['provider'] = this.selectedConferenceProvider.key;
      if (this.selectedInterviewers && this.selectedInterviewers.length > 0) {
        payload['interviewers'] = this.selectedInterviewers;
      }
    }
  
    this.eventServices.sendInterviewLinkFastApi(payload, this.eventId, this.stage.stageId).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.body.detail,
        });
        this.sendLinkForm.reset({
          candidates: [],
          interviewDate: null,
          startTime: null,
          duration: null,
          jobRoleId: null,
          venue: null,
          sendEmail: true,
          agentId: null
        });
        this.clicked = false;
        this.sendLinkSlider = false;
        this.getCandidates();
        this.uploadBtnLoading = false;
        this.selectedUsersList = [];
        this.selectedInterviewers = [];
        this.selectedConferenceProvider = null;
        this.showAvailabilityPanel = false;
        this.availabilityData = [];
      },
      error: (error) => {
        this.uploadBtnLoading = false;
      }
    });
  };

  handleSendTestLink = () => {
    if (!this.stage.contest?.uuid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'No Test is mapped to this stage. Please map the test first.',
      });
      return;
    }
    this.sendTestLink(this.selectedUsersList);
  };

  sendTestLink = async (users: any) => {
    this.loadingSpinner = true;
    let payload: any;
    payload = {
      candidate_uuids: users.map((user: any) => user.id),
    }
    // if (this.selectedAllStageCandidates) {
      // For sending test link to all candidates
      this.eventServices.sendTestLinkFastApi(payload, this.stage.stageId, this.eventId).subscribe({
        next: (res: any) => {
          if (res.status == 200) {
            this.messageService.add({
              severity: 'success',
              summary: 'Test Link Successfully Sent',
              detail: res.body.detail,
            });
          }
          this.getCandidates();
          this.selectedUsersList = [];
          this.loadingSpinner = false;
        },
        error: () => {
          this.loadingSpinner = false;
        }
      });
  };

  confirmSyncScores = () => {
    this.showSyncScoresConfirmDialog = true;
  };

  closeSyncScoresConfirmDialog = () => {
    this.showSyncScoresConfirmDialog = false;
  };

  syncTestScores = () => {
    this.showSyncScoresConfirmDialog = false;
    this.syncScoresLoading = true;
    this.eventServices.syncTestScoresFastApi(this.eventId, this.stage.stageId).subscribe({
      next: (response: any) => {
        this.syncScoresLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.body?.detail || 'Test scores synced successfully',
        });
        this.getCandidates();
      },
      error: (error: any) => {
        this.syncScoresLoading = false;
      }
    });
  };

  confirmSyncContest = () => {
    this.showSyncContestConfirmDialog = true;
  };

  closeSyncContestConfirmDialog = () => {
    this.showSyncContestConfirmDialog = false;
  };

  syncContest = () => {
    this.showSyncContestConfirmDialog = false;
    this.syncContestLoading = true;
    this.eventServices.syncContestFastApi(this.eventId, this.stage.stageId).subscribe({
      next: (response: any) => {
        this.syncContestLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.body?.detail || 'Contest synced successfully',
        });
        this.getCandidates();
      },
      error: (error: any) => {
        this.syncContestLoading = false;
      }
    });
  };
  
  

  changeFormat = (value: string): string => {
    if (!value) {
      return '';
    } else {
      let tempDate = new Date().toISOString().split('T')[0];
      let ap = value.split(' ')[1];
      if (ap == 'PM' || ap == 'pm') {
        let hh = Number(value.split(' ')[0].split(':')[0]);
        if (hh != 12) {
          hh += 12;
          value = hh + ':' + value.split(':')[1].split(' ')[0];
        }
      }
      return new Date(tempDate + ' ' + value.split(' ')[0])
        .toISOString()
        .split('T')[1];
    }
  };

  getCandidates = () => {
    //Cohort Funcitons
    this.cohortBtnLoading = false;
    this.cohortErroredFile = [];
    this.showJoiningDate = '';
    this.selectedJoinDate = '';
    this.errorFileUrl = '';
    this.interviewFileName = '';
    this.testFileName = '';
    this.templateUploaded = false;
    this.scheduleBtnLoading = false;
    this.testScheduleBtnLoading = false;
    this.template = [];

    //Move Stage Funcitons
    this.filterLoading = false;
    this.loadingSpinner = true;
    this.emailList.emit([]);
    let copyCandidateList = this.candidateList;
    this.candidateList = [];
    this.selectedAllStageCandidates = false;

    if ( this.filterCriteria?.length > 0 ||
      this.assessmentRange?.length == 2 || this.contestValidityRange?.length == 2 || (this.firstValue >= 0 && this.secondValue >= 0) || this.rangeDates?.length == 2) {
      let testPayload: any;
      let joinedPayload: any;

      this.filterCriteria.forEach((item: any) => {
        if (Array.isArray(item.filterValue)) {
          this.filterCount = this.filterCount + item.filterValue.length;
        }
        else {
          this.filterCount = this.filterCount + 1;
        }
      })
      if (this.filterCount > 7) {
        this.messageService.add({ severity: 'info', summary: 'Message', detail: 'Please select within a total of 7 filter values to proceed !' });
        this.filterCount = 0;
        this.candidateList = copyCandidateList;
        this.loadingSpinner = false;
      }
      else {
        this.filterCount = 0;
        if (this.assessmentRange.length == 2 || this.contestValidityRange.length == 2 || (this.firstValue >= 0 && this.secondValue >= 0)) {
          testPayload = this.applyFilter();
        }
        if (this.rangeDates?.length == 2) {
          joinedPayload = this.dateFilter();
        }
        let payload: any = {};
        let finalPayload: any = {};
        let searchTerm: string = '';
        if (this.search.length) {
          this.search = this.search.filter((item: any) => item != '')
        }
        if (this.search && this.search.length === 1) {
          searchTerm = this.search[0];
        } else if(this.search.length > 0)  {
          searchTerm = this.search.join(' ');
        }
        // if (this.search && this.search.length === 1) {
        //   searchTerm = this.search[0];
        // } else {
        //   payload.search = this.search;
        //   payload.filterCriteria = this.filterCriteria;
        // }
        // if (testPayload) {
        //   finalPayload.testStagePayload = testPayload;
        //   finalPayload.allStagePayload = payload;
        // } else if (joinedPayload) {
        //   finalPayload.joinStagePayload = joinedPayload;
        //   finalPayload.allStagePayload = payload;
        // } else {
        //   finalPayload.allStagePayload = payload;
        // }
        this.eventServices
        .getEventStageCandidatesFastApi(
          this.stage.stageId,
          this.eventId,
          this.pageNumber,
          this.pageSize,
          this.order_by,
          this.sort_by,
          searchTerm,
          {
            filterCriteria: JSON.parse(JSON.stringify(this.filterCriteria))
          }
        )
        .subscribe({
          next: (result: any) => {
            const candidates = result?.body?.items || [];
            this.candidateList = candidates.map((c: any) => ({
              id: c.candidate_uuid ?? '-',
              name: c.candidate?.name ?? '-',
              email: c.candidate?.email ?? '-',
              photo: c.candidate?.photo || null,
              dob: c.candidate?.dob ?? '-',
              gender: c.candidate?.gender ?? '-',
              mobile_number: c.candidate?.mobile_number ?? '-',
              stageId: c.stage?.current_stage ?? '-',
              ...c,
              offerResponse: c.offer_info?.offer_response ?? c.event_offer?.offer_response ?? '-',
              declinedRemarks: c.offer_info?.declining_reason ?? c.event_offer?.declining_reason ?? '-',
              status: typeof c.status === 'object' ? c.status?.name ?? '-' : c.status ?? '-',
              documentPOC: c.document_poc?.name ?? '-',    
              isDocumentsSubmitted: c.document_status?.status === 'Submitted',
              isFeedbackSubmitted: (c.feedback_status ?? c.interview_info?.feedback_status)?.status === 'Submitted',
              feedbackStatus: (c.feedback_status ?? c.interview_info?.feedback_status)?.status ?? 'Not Submitted',
              documentSubmittedAt: c.document_status?.submitted_at ?? '-',
              jobRole: c.job_role?.name ?? '-',
              offerLocations: c.event_offer?.locations ? c.event_offer.locations.join(', ') : '-',
              registeredAt: c.registered_at ?? '-',
              documentationCreatedAt: c.documentation_created_at ?? c.documentation_info?.created_at ?? '-',
              documentationDeadline: c.documentation_deadline ?? c.documentation_info?.deadline ?? '-',
              offerSentAt: c.offer_sent_at ?? c.offer_info?.created_at ?? '-',
              offerDeadline: c.offer_deadline ?? c.offer_info?.deadline ?? '-',
              offerSubmittedAt: c.offer_submitted_at ?? c.offer_info?.offer_submitted_at ?? '-',
              interviewStartAt: c.interview_info?.interview_start_at ?? '-',
              collegeName: c.candidate?.college_names?.[0] ?? '-',
            }));

            this.candidateList.forEach((candidate: any) => {
              const testScoreObject: { [stageName: string]: any } = {};
              if (candidate.event_tests && candidate.event_tests.length > 0) { 
                candidate.event_tests.forEach((eventTest: any) => {
                  const stageUuid = eventTest.event_stage.uuid;
                  testScoreObject[stageUuid] = {
                    marks: eventTest.marks,
                    total_marks: eventTest.total_marks,
                    stageId: candidate.stage?.current_stage,
                    stageName: eventTest.event_stage.name,
                    result_analysis_url: eventTest.result_analysis_url
                  };
                });
                const currentStageTest = this.getCurrentStageDataByStageUuid(candidate, this.stage?.uuid);
                
                if (currentStageTest) {
                  candidate.testStartTime = this.formatDateTime(currentStageTest.start_time);
                  candidate.testSubmitTime = this.formatDateTime(currentStageTest.submit_time);
                  candidate.contestStartTime = this.formatDateTime(currentStageTest.event_stage.contest.start_datetime);
                  candidate.contestEndTime = this.formatDateTime(currentStageTest.event_stage.contest.end_datetime);
                }
              }
              candidate.testScore = testScoreObject;
            });
      
            this.totalLength = result.body.total || 0;
            this.first = result.body.page || 1;
            this.last = result.body.pages || 10;
            this.pageSize = result.body.size || 10;
            this.totalPages = result.body.pages || 1;
            this.loadingSpinner = false;
            this.emptyStage.emit(this.candidateList.length === 0);
          },
          error: () => {
            this.loadingSpinner = false;
          }
        });      
      }
    } else {
      let searchTerm: string = '';
      if (this.search.length) {
        this.search = this.search.filter((item: any) => item != '')
      }
      if (this.search && this.search.length === 1) {
        searchTerm = this.search[0];
      } else if(this.search.length > 0)  {
        searchTerm = this.search.join(' ');
      }
      this.eventServices.getEventStageCandidatesFastApi(this.stage.stageId,this.eventId ,this.pageNumber, this.pageSize,  this.order_by, this.sort_by, searchTerm || undefined).subscribe({
        next: (result: any) => {
          const candidates = result?.body?.items || [];
          this.candidateList = candidates.map((c: any) => ({
            id: c.candidate_uuid ?? '-',
            name: c.candidate?.name ?? '-',
            email: c.candidate?.email ?? '-',
            photo: c.candidate?.photo || null,
            dob: c.candidate?.dob ?? '-',
            gender: c.candidate?.gender ?? '-',
            mobile_number: c.candidate?.mobile_number ?? '-',
            stageId: c.stage?.current_stage ?? '-',
            ...c,
            offerResponse: c.offer_info?.offer_response ?? c.event_offer?.offer_response ?? '-',
            declinedRemarks: c.offer_info?.declining_reason ?? c.event_offer?.declining_reason ?? '-',
            status: typeof c.status === 'object' ? c.status?.name ?? '-' : c.status ?? '-',
            documentPOC: c.document_poc?.name ?? '-',    
            isDocumentsSubmitted: c.document_status?.status === 'Submitted',
            isFeedbackSubmitted: (c.feedback_status ?? c.interview_info?.feedback_status)?.status === 'Submitted',
            feedbackStatus: (c.feedback_status ?? c.interview_info?.feedback_status)?.status ?? 'Not Submitted',
            documentSubmittedAt: c.document_status?.submitted_at ?? '-',
            jobRole: c.job_role?.name ?? '-',
            offerLocations: c.event_offer?.locations ? c.event_offer.locations.join(', ') : '-',
            registeredAt: c.registered_at ?? '-',
            documentationCreatedAt: c.documentation_created_at ?? c.documentation_info?.created_at ?? '-',
            documentationDeadline: c.documentation_deadline ?? c.documentation_info?.deadline ?? '-',
            offerSentAt: c.offer_sent_at ?? c.offer_info?.created_at ?? '-',
            offerDeadline: c.offer_deadline ?? c.offer_info?.deadline ?? '-',
            offerSubmittedAt: c.offer_submitted_at ?? c.offer_info?.offer_submitted_at ?? '-',
            interviewStartAt: c.interview_info?.interview_start_at ?? '-',
            collegeName: c.candidate?.college_names?.[0] ?? '-',
          }));

          this.candidateList.forEach((candidate: any) => {
            const testScoreObject: { [stageName: string]: any } = {};
            if (candidate.event_tests && candidate.event_tests.length > 0) { 
              
              candidate.event_tests.forEach((eventTest: any) => {
                const stageUuid = eventTest.event_stage.uuid;
                testScoreObject[stageUuid] = {
                  marks: eventTest.marks,
                  total_marks: eventTest.total_marks,
                  stageId: candidate.stage?.current_stage,
                  stageName: eventTest.event_stage.name,
                  result_analysis_url:eventTest.result_analysis_url
                };
              });
              const currentStageTest = this.getCurrentStageDataByStageUuid(candidate, this.stage?.uuid);
              
              if (currentStageTest) {
                candidate.testStartTime = this.formatDateTime(currentStageTest.start_time);
                candidate.testSubmitTime = this.formatDateTime(currentStageTest.submit_time);
                candidate.contestStartTime = this.formatDateTime(currentStageTest.event_stage.contest.start_datetime);
                candidate.contestEndTime = this.formatDateTime(currentStageTest.event_stage.contest.end_datetime);
              }
            }
            candidate.testScore = testScoreObject;
          });
          this.numberOfStages = this.candidateList.length > 0 ? this.candidateList[0].stage.total_stage : 0;
          this.emptyStage.emit(this.candidateList.length === 0);
          if (this.selectedUsersList.length) {
            this.selectedUsersList = this.candidateList.filter((user:any) => 
              this.selectedUsersList.some((each:any) => user.id === each.id)
            );
          }
          this.loadingSpinner = false;
          this.cdRef.detectChanges();
          this.totalLength = result.body.total || 0;
          this.first = result.body.page || 1;
          this.last = result.body.pages || 10;
          this.pageSize = result.body.size || 10;
          this.totalPages = result.body.pages || 1;
        },
        error: () => {
          this.loadingSpinner = false;
        }
      });
    }
  };
  formatDateTime(dateValue: string | Date): string {
    if (!dateValue) return '-';
    const dateObj = new Date(dateValue);  
    const finalTimeFormat = this.timeFormat?.includes('a') ? this.timeFormat : `${this.timeFormat} a`;
    const storedFormat = `${this.dateFormat} ${finalTimeFormat}`;
    return this.datePipe.transform(dateObj, storedFormat) || '-';
  }
  viewResultAnalysis(user: any, stageId?: string): void {
    let resultAnalysisUrl = '';    
    if (stageId && user?.testScore?.[stageId]) {
      resultAnalysisUrl = user.testScore[stageId].result_analysis_url;
    }
    if (resultAnalysisUrl && resultAnalysisUrl.trim() !== '') {
        window.open(resultAnalysisUrl, '_blank');
    } else {
        this.messageService.add({
            severity: 'warn',
            summary: 'No Result Analysis Available',
            detail: 'There is no result analysis URL for this candidate.'
        });
    }
}

  getUsersByLimit = () => {
    this.pageNumber = 1;
    this.first = 1;
    this.last =
      this.pageSize < this.totalLength ? this.pageSize : this.totalLength;
    (this.filterApplied) ? this.applySelectedFilter() : this.getCandidates();
  };

  exportCandidate = (type: string) => {
    let checkedColumnFields: any = ['name', 'id'];
    this.checkedColumns.forEach((each) => {
      checkedColumnFields.push(each.field);
    });
    let afterFilter: any = [];
    if (this.selectedUsersList.length) {
      afterFilter = this.processExcel(this.selectedUsersList, checkedColumnFields, type);
    } else {
      afterFilter = this.processExcel(this.candidateList, checkedColumnFields, type);
    }
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(afterFilter);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: type === 'excel' ? 'xlsx' : 'csv',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, this.exportName, type);
    });
  };

  processExcel = (usersList: Array<any>, checkedColumnFields: any, type: string) => {
    let afterFilter: any = [];
    usersList.forEach((eachData: any) => {
      eachData.feedbackStatus = (eachData.feedbackStatus) ? eachData.feedbackStatus : 'Feedback not Submitted';
      eachData.testScore = (eachData.testScore instanceof Array && eachData.testScore.length > 0) ? (eachData.testScore[0].marks + '/' + eachData.testScore[0].total_marks) : '-';
      let filterData: any = {};
      if (this.stage.type == 'Others') {
        if (!eachData.location) { eachData.location = '-' }
        if (!eachData.jobRole) { eachData.jobRole = '-' }
      }
      checkedColumnFields.forEach((item: any) => {
        eachData.hasOwnProperty(item) && (filterData[item] = eachData[item]);
        switch (item) {
          case "cohort_name":
            filterData[item] = eachData.userCohortData[item] ?? '-';
            break;
          case "cohort_date":
            filterData[item] = eachData.userCohortData['date'] ?? '-';
            break;
          case "cohort_spoc":
            filterData[item] = eachData.userCohortData[item]?.email ?? '-';
            break;
        }
      });
      afterFilter.push(filterData);
    });
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(afterFilter);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: type === 'excel' ? 'xlsx' : 'csv',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, this.exportName, type);
    });
  };

  exportAllCandidates = (type: string) => {
    this.loadingDownload = true;
    let keys = this.checkedColumns.map(col =>
    col.field === "testScore" && col.stageId ? col.stageId : col.field
  );

  let searchTerm: string = '';
  if (this.search && this.search.length) {
    const filteredSearch = this.search.filter((item: any) => item != '');
    if (filteredSearch.length === 1) {
      searchTerm = filteredSearch[0];
    } else if (filteredSearch.length > 0) {
      searchTerm = filteredSearch.join(' ');
    }
  }

  const fieldMapping: { [key: string]: string } = {
      jobRole: "job_role_id",
      jobStatus: "status",
      isPWD: "pwd_status",
      arrears: "arrears_status",
      graduationYear: "end_date",
      degreeBranch: "specialization",
      degree: "degree",
      collegeName: "college_name",
    };

  const activeFilters = this.filterCriteria.reduce((accumulator, currentFilter) => {
    if (currentFilter.filterValue != null && 
        currentFilter.filterValue !== '' && 
        !(Array.isArray(currentFilter.filterValue) && currentFilter.filterValue.length === 0)) {
      const newKey = fieldMapping[currentFilter.filterField] || currentFilter.filterField;
      accumulator[newKey] = currentFilter.filterValue;
    }
    return accumulator;
  }, {} as { [key: string]: any });

  const payload = {
    "file_type": type,
    "columns": keys,
    "requested_data": "all",
    "ids": null, // 'ids' would be used if you were exporting only user-selected candidates
    "stage_uuid": this.stage.stageId,
    "search": searchTerm || null,
    "filters": Object.keys(activeFilters).length > 0 ? activeFilters : null
  };

  // 2. Calls the service, passing the payload for the BODY and the
  //    activeFilters object for the URL QUERY PARAMETERS.
  this.eventServices
    .eventStageCandidateExportFastApi(
      this.eventId,
      this.stage.stageId,
      payload,
      activeFilters // Pass the simple filter object here
    ).subscribe({
      next: (response: HttpResponse<any>) => {
        // 3. Handles the success response by showing a toast message.
        this.loadingDownload = false;
        const message = response.body?.message || 'Export process has been initiated successfully.';
        
        this.messageService.add({
          severity: 'success',
          summary: 'Process Started',
          detail: message
        });
        this.showDownloadSidebar = false;
        this.resetCheckedColumnsToDefault();
      },
      error: (error: HttpErrorResponse) => {
        this.loadingDownload = false;
        let errorMessage = 'Failed to download candidates data';
        
        if (error.status === 403) {
          errorMessage = 'Access denied. You do not have permission for this action.';
        } else if (error.error && error.error.detail && Array.isArray(error.error.detail)) {
          const firstError = error.error.detail[0];
          errorMessage = firstError.msg || firstError.ctx?.error || errorMessage;
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (error.error?.detail) {
          errorMessage = error.error.detail;
        }
        
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage
        });
      }
    });
  };
  saveCohortExcelFile(buffer: any, fileName: string, type: string): void {
    let FILE_TYPE =
      type === 'excel'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        : 'text/csv';
    let FILE_EXTENSION = type === 'excel' ? '.xlsx' : '.csv';
    const data: Blob = new Blob([buffer], {
      type: FILE_TYPE,
    });
    saveAs(data, fileName + '_export_' + new Date().getTime() + FILE_EXTENSION);
    this.showDownloadSidebar = false;
    this.resetCheckedColumnsToDefault();
  }

  saveAsExcelFile(buffer: any, fileName: string, type: string): void {
    let FILE_TYPE =
      type === 'excel'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        : 'text/csv';
    let FILE_EXTENSION = type === 'excel' ? '.xlsx' : '.csv';
    const data: Blob = new Blob([buffer], {
      type: FILE_TYPE,
    });
    saveAs(data, fileName + '_export_' + new Date().getTime() + FILE_EXTENSION);
    this.showDownloadSidebar = false;
    this.resetCheckedColumnsToDefault();
  }

  applySelectedColumns = () => {
    this._selectedColumns = this.sortedColumns();
    this.showSettingsSidebar = false;
  };

  clearSelectedColumns = () => {
    this.checkedColumns = [];
  };

  showSaveColumnSettings = () => {
    this.displaySaveColumnSettings = true;
  };

  searchColumns = (searchTerm: string) => {
    if (this.showSettingsSidebar) {
      this._candidatesCol = this.candidatesCol.filter((val) =>
        val.header.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (this.showDownloadSidebar) {
      this.colsToDownload = this.candidatesCol.filter((val) =>
        val.header.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  };

  applySavedSettings = (savedColumnValue: Array<any>) => {
    this.checkedColumns = this.candidatesCol.filter((e) =>
      savedColumnValue.includes(e.field)
    );
  };

  private sortedColumns(): any[] {
    return this.checkedColumns;
  }

  setStatusDropdown = (status: any) => {
    this.statusOptions.forEach((each: any) => {
      if (status == each.name) this.currentStatus = each;
    });
  };

  changeStatus = (status: any) => {
    this.loadingSpinner = true;
    this.uploadBtnLoading = true;

    let payload: any = {
      current_stage_uuid: this.stage.stageId,
      change_status_id : status.id,
      candidate_uuids: this.selectedUsersList.map((user: any) => user.id),
      remarks: this.activityRemarks,
    };
    this.eventServices.candidateStageUpdateStatusFastApi(payload,this.stage.id, this.eventId).subscribe({
      next: (result: any) => {
        if (this.selectedUsersList.length == 1) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: result.body.detail,
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Message',
            detail: 'Bulk process has been initiated. Kindly refresh after some times.'
          });
        }
        this.showJoiningDate = '';
        this.selectedJoinDate = '';
        this.selectedUsersList = [];
        this.activityRemarks = '';
        this.stageActivitySlider = false;
        this.uploadBtnLoading = false;
      },
      error: () => {
        this.showJoiningDate = '';
        this.selectedJoinDate = '';
        this.selectedUsersList = [];
        this.activityRemarks = '';
        this.stageActivitySlider = false;
        this.loadingSpinner = false;
        this.uploadBtnLoading = false;
      }
    });
  }

  // Pagination
  next(): void {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedUsersList=[];
    this.first = this.first + this.pageSize;
    this.last =
      this.last + this.pageSize < this.totalLength
        ? this.pageSize + this.last
        : this.totalLength;
    this.pageNumber += 1;
    this.getCandidates();
  }

  prev(): void {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedUsersList=[];
    this.first = this.first - this.pageSize;
    this.last =
      this.last - this.pageSize >= this.totalLength
        ? this.totalLength - this.last
        : this.pageSize;
    this.pageNumber -= 1;
    this.getCandidates();
  }

  isLastPage(): boolean {
    return !this.totalPages || this.pageNumber === this.totalPages;
  }

  isFirstPage(): boolean {
    return this.first > 1 ? false : true;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.candidatesCol.filter((col) =>
      val.includes(col)
    );
  }

  showCandidateDetails(userDetail: any) {
    this.displayUserDetails = true;
    this.selectedUser = userDetail;
  }

  sendEmail() {
    this.sendEmailSlider = true;
  }

  mailSent(event: boolean) {
    this.sendEmailSlider = false;
    this.sendOfferMail = false;
    this.sendDocumentation = false;
    this.sentInterviewVenue = false;
    if (event) {
      this.getCandidates();
      this.selectedUsersList = [];
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Mail Sent!' });
    }
  }

  capitalize(col: any) {
    let nonCapitializeField = ["email", "jobRole", "offerLocations", "submissionDeadline", "registeredAt", "documentationCreatedAt", "documentationDeadline", "documentSubmittedAt", "offerSentAt", "offerDeadline", "offerSubmittedAt", "interviewStartAt", "testStartTime", "testSubmitTime", "contestStartTime", "contestEndTime"]
    if (!(nonCapitializeField.includes(col.field))) {
      return true
    }
    return false
  }

  getUserName(userId: string) {
    let user = this.eventUsers.filter((user: any) => user.id == userId)[0];
    return user?.name;
  }

  statusButton(status: any) {
    if (this.stage.stageId == 1) {
      if (this.selectedUsersList.length == 1) {
        if (status.value == this.selectedUsersList[0].status) {
          return true;
        }
      }
      return false;
    }
    return false;
  }
  fetchCandidateDetails(formType: 'documentation' | 'feedback', user: any, index?: number) {
    if (!user?.id || !this.eventId) return;
  
    this.isLoadingDetails = true;
    this.selectedUser = user;    
    let targetFormId: number | null = null;
    
    if (formType === 'documentation') {
      targetFormId = user.document_status?.id || null;
    } else if (formType === 'feedback') {
      targetFormId = (user.feedback_status ?? user.interview_info?.feedback_status)?.id ?? null;
    }
  
    if (!targetFormId) {
      console.error(`No ${formType} form ID found for user:`, user);
      this.isLoadingDetails = false;
      return;
    }
  
    this.jobService.getCandidateFormDetails(this.eventId, formType, targetFormId).subscribe(
      async (response: any) => {
        if (response?.body?.form_details) {
          this.fieldLookupService.setFormFieldOptions(this.eventId, response.body.form_details);
        }
        const details = response?.body?.form_details
          ? await this.processData(response.body.form_details, response.body.candidate_details)
          : [{ label: "No Data Found", value: "-" }];
  
        if (formType === 'documentation') {
          if (index !== undefined) {
            this.allDocumentationDetails[index] = details;
          } else {
            this.documentationDetails = details;
            this.documentationSections = this.getGroupedSections(this.documentationDetails);
          }
          this.showDocumentationDialog = true;
        } else if (formType === 'feedback') {
          if (index !== undefined) {
            this.allFeedbackDetails[index] = details;
          } else {
            this.feedbackDetailsData = details;
            this.feedbackSections = this.getGroupedSections(this.feedbackDetailsData);
          }
          this.showFeedbackDialog = true;
        }
  
        this.isLoadingDetails = false;
      },
      (error) => {
        console.error('Error fetching candidate details:', error);
        this.isLoadingDetails = false;
      }
    );
  }
  
  onDocumentationIconClick(user: any, index?: number) {
    this.fetchCandidateDetails('documentation', user, index);
  }
  
  onFeedbackIconClick(user: any, index?: number) {
    this.feedbackFormUuid = this.stage?.feedback_form?.uuid || this.stage?.form?.uuid;
    
    if (!this.feedbackFormUuid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No feedback form found for this stage'
      });
      return;
    }
    
    this.feedbackHeaderData = {
      eventId: this.eventId,
      stageId: this.stage.id,
      userID: user.id,
      candidateEmail: user.email
    };
    
    this.selectedCandidateForFeedback = {
      candidate_name: user.name,
      candidate_uuid: user.id,
      candidate_email: user.email,
      stage_uuid: this.stage.stageId,
      event_uuid: this.eventId,
      profilePic: user.photo,
      interview_uuid: user.interview_info?.interview_uuid,
      showAllInterviews: true,
    };
    
    this.feedbackMode = user.isFeedbackSubmitted 
      ? (this.userPrivileges.has('event_interview.edit_feedback_form') ? 'edit' : 'view')
      : 'create';
    this.originalFeedbackMode = this.feedbackMode;
    this.isViewOnlyFeedback = false;
    this.panelMembers = [];
    this.selectedPanelMemberId = null;
    this.feedbackSlider = true;
  }
  
  onCloseFeedbackSlider(success: boolean) {
    this.feedbackSlider = false;
    this.selectedCandidateForFeedback = null;
    this.feedbackFormUuid = '';
    this.feedbackHeaderData = {};
    this.panelMembers = [];
    this.groupedPanelMembers = [];
    this.selectedPanelMemberId = null;
    this.selectedPanelMemberFormId = null;
    this.isViewOnlyFeedback = false;
    if (success) {
      this.getCandidates();
    }
  }
  
  onFeedbackDialogHide() {
    this.feedbackSlider = false;
    this.selectedCandidateForFeedback = null;
    this.feedbackFormUuid = '';
    this.feedbackHeaderData = {};
    this.panelMembers = [];
    this.groupedPanelMembers = [];
    this.selectedPanelMemberId = null;
    this.selectedPanelMemberFormId = null;
    this.isViewOnlyFeedback = false;
  }

  selectPanelMember(member: any) {
    const key = member.isVirtual ? `v-${member.submitted_by_id}` : `f-${member.form_id}`;
    const currentKey = this.selectedPanelMemberFormId != null ? `f-${this.selectedPanelMemberFormId}` : (this.selectedPanelMemberId != null ? `v-${this.selectedPanelMemberId}` : null);
    if (currentKey === key) return;

    this.selectedPanelMemberId = member.submitted_by_id;
    this.selectedPanelMemberFormId = member.isVirtual ? null : (member.form_id ?? null);
    const isCurrentUser = member.submitted_by_id === this.currentUserId;

    if (member.isVirtual) {
      this.feedbackMode = 'create';
      this.isViewOnlyFeedback = false;
      this.feedbackFormComponent?.resetToCreateMode();
    } else {
      this.isViewOnlyFeedback = !isCurrentUser;
      this.feedbackMode = isCurrentUser ? this.originalFeedbackMode : 'view';
      this.feedbackFormComponent?.loadPanelMemberFeedback(member.form_id);
    }
  }

  onPanelMembersLoaded(members: any[]) {
    if (this.panelMembers.length > 0) return;
    this.panelMembers = members.sort((a: any, b: any) => {
      if (a.submitted_by_id === this.currentUserId) return -1;
      if (b.submitted_by_id === this.currentUserId) return 1;
      return 0;
    });
    this.groupedPanelMembers = this.groupMembersByInterview(this.panelMembers);

    const currentUserMember = this.panelMembers.find(
      (m: any) => m.submitted_by_id === this.currentUserId
    );
    if (currentUserMember) {
      this.selectedPanelMemberId = currentUserMember.submitted_by_id;
      this.selectedPanelMemberFormId = currentUserMember.form_id ?? null;
      this.feedbackMode = this.originalFeedbackMode;
      this.isViewOnlyFeedback = false;
      if (currentUserMember.form_id) {
        this.feedbackFormComponent?.loadPanelMemberFeedback(currentUserMember.form_id);
      }
    } else if (this.panelMembers.length > 0) {
      const currentUserEntry = {
        submitted_by_id: this.currentUserId,
        submitted_by_name: this.loggedUserDetails?.name || 'You',
        submitted_date: null,
        isVirtual: true
      };
      this.panelMembers = [currentUserEntry, ...this.panelMembers];
      if (this.groupedPanelMembers.length > 0) {
        const currentInterviewUuid = this.selectedCandidateForFeedback?.interview_uuid;
        const targetGroup = this.groupedPanelMembers.find(g => g.interview_uuid === currentInterviewUuid)
          || this.groupedPanelMembers[0];
        targetGroup.members = [currentUserEntry, ...targetGroup.members];
      }
      this.selectedPanelMemberId = this.currentUserId;
      this.selectedPanelMemberFormId = null;
      this.feedbackMode = 'create';
      this.isViewOnlyFeedback = false;
      this.feedbackFormComponent?.resetToCreateMode();
    }
  }

  private groupMembersByInterview(members: any[]): { label: string, interview_uuid: string, members: any[] }[] {
    const grouped = new Map<string, any[]>();
    const order: string[] = [];
    members.forEach(m => {
      const uuid = m.interview_uuid || 'unknown';
      if (!grouped.has(uuid)) {
        grouped.set(uuid, []);
        order.push(uuid);
      }
      grouped.get(uuid)!.push(m);
    });
    return order.map((uuid, index) => ({
      label: `Interview ${index + 1}`,
      interview_uuid: uuid,
      members: grouped.get(uuid)!
    }));
  }
  closeDocumentationDialog() {
    this.showDocumentationDialog = false;
    this.documentationDetails = [];
    this.documentationSections = [];
  }
  
  closeFeedbackDialog() {
    this.showFeedbackDialog = false;
    this.feedbackDetailsData = [];
    this.feedbackSections = [];
  }

  trackBySectionName = (index: number, section: { name: string }) => section?.name ?? index;
  trackByIndex = (index: number) => index;

  getGroupedSections(data: any[]): { name: string, fields: any[] }[] {
    const grouped: { [key: string]: any[] } = {};
  
    data.forEach(item => {
      const section = item.section || 'Other';
      if (!grouped[section]) {
        grouped[section] = [];
      }
      grouped[section].push(item);
    });
  
    return Object.keys(grouped).map(section => ({
      name: section,
      fields: grouped[section]
    }));
  }
  
  async processData(formDetails: any, candidateDetails: any): Promise<any[]> {
    let formattedData: any[] = [];
    const hasFormStructure = formDetails && Object.keys(formDetails).length > 0;
    
    if (!hasFormStructure && candidateDetails) {
      return this.groupFlatCandidateFields(candidateDetails);
    }
    
    if (!formDetails || !candidateDetails) {
      return [{ section: "No Data Found", label: "", value: "-" }];
    }
    
    await this.fieldLookupService.loadLookupData(this.eventId, formDetails);
  
    Object.entries(formDetails).forEach(([section, fields]: [string, any]) => {
      let sectionData: any[] = [];
  
      fields.forEach((field: any) => {
        let fieldValue = candidateDetails[field.field_name] ?? "-";
  
        if (typeof fieldValue === 'string' && this.isUrl(fieldValue)) {
          fieldValue = `<a href="${fieldValue}" target="_blank" title="View File"><i class="pi pi-eye"></i></a>`;
          sectionData.push({
            section: section,
            label: field.field_label,
            value: fieldValue
          });
        } else if (fieldValue !== "-" && fieldValue !== null && fieldValue !== "") {
          fieldValue = this.getFieldValueLabel(fieldValue, field.field_options);          
          if (fieldValue === candidateDetails[field.field_name] && this.fieldLookupService.isFieldSupported(field.field_name)) {
            fieldValue = this.fieldLookupService.getLookupValue(field.field_name, fieldValue, this.eventId);
          }
          sectionData.push({
            section: section,
            label: field.field_label,
            value: fieldValue
          });
        } else {
          sectionData.push({
            section: section,
            label: field.field_label,
            value: fieldValue
          });
        }
      });
  
      if (sectionData.length > 0) {
        formattedData = [...formattedData, ...sectionData];
      }
    });
  
    return formattedData.length ? formattedData : [{ section: "No Data Found", label: "", value: "-" }];
  }
  
  groupFlatCandidateFields(candidateDetails: any): any[] {
    const readable = Object.entries(candidateDetails)
      .filter(([key, value]) => key !== 'id' && key !== 'candidate_uuid' && value !== null && value !== '')
      .map(([key, value]) => {
        if ((key === 'created_at' || key === 'updated_at') && typeof value === 'string') {
          value = this.formatDate(value);
        }
        return {
          section: 'Details Summary',
          label: this.formatFieldName(key),
          value: value
        };
      });
    return readable.length ? readable : [{ section: "No Data Found", label: "", value: "-" }];
  }
  
  isUrl(value: string): boolean {
    const urlPattern = /^(https?:\/\/[^\s]+)/i;
    return urlPattern.test(value);
  }
  

  formatFieldName(key: string): string {
    return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }
  
  formatDate(dateString: string): string {
    try {
      return new Date(dateString).toLocaleString();
    } catch {
      return dateString;
    }
  }
  
  isFileField(fieldName: string): boolean {
    const fileFields = ["resume_cv", "cover_letter"];
    return fileFields.includes(fieldName);
  }

  getFieldValueLabel(fieldValue: any, fieldOptions: any[]): any {
    if (!fieldValue || fieldValue === '') return '-';
    if (!fieldOptions?.length) return fieldValue;
    
    if (Array.isArray(fieldValue)) {
      if (fieldValue.length === 0) return '-';
      return fieldValue.map(val => {
        const option = fieldOptions.find(opt => opt.value == val);
        return option ? option.label : val;
      }).join(', ');
    }
    
    const option = fieldOptions.find(opt => opt.value == fieldValue);
    return option ? option.label : fieldValue;
  }

  getStageIdFromColumn(column: any): string | null {
    if (!column || !column.stageId) {
      return null;
    }
    
    return column.stageId;
  }

  getTestScoreByStageId(user: any, stageId: string | null): any {
    if (!user?.testScore || !stageId || typeof user.testScore !== 'object') {
      return null;
    }
    const score = user.testScore[stageId] || null;
    if (!score || score.marks === undefined || score.marks === null) {
      return null;
    }
    return score;
  }

  getCurrentStageDataByStageUuid(user: any, stageUuid: string): any {
    if (!user.event_tests || !stageUuid || !Array.isArray(user.event_tests)) {
      return null;
    }
    
    return user.event_tests.find((test: any) => 
      test.event_stage.uuid === stageUuid
    ) || null;
  }

  loadInterviewJobRoles() {
    const sharedService = this.globalService.getSharedService();
    const cachedEventData = sharedService.getEventDetails(this.eventId);
    
    if (cachedEventData && cachedEventData.event_details) {
      this.handleInterviewJobRoles(cachedEventData.event_details);
    } else {
      this.getEventDetailsForJobRoles();
    }
  }

  loadConferenceProviders() {
    this.conferenceProviders = [{ ...this.defaultJitsiProvider, selectDisabled: false }];
    if (!this.selectedConferenceProvider) {
      this.selectedConferenceProvider = this.defaultJitsiProvider;
    }
    if (!this.lastConnectedProvider) {
      this.lastConnectedProvider = this.selectedConferenceProvider?.is_integrated ? this.selectedConferenceProvider : this.defaultJitsiProvider;
    }

    this.isLoadingProviders = true;
    this.settingsService.getConferenceProviders().subscribe({
      next: (res: any) => {
        if (res.status === 200 && res.body?.items) {
          const all = [this.defaultJitsiProvider, ...res.body.items];
          this.conferenceProviders = all.map((p: any) => ({ ...p, selectDisabled: !p.is_integrated }));
          const currentKey = this.selectedConferenceProvider?.key;
          const found = this.conferenceProviders.find((p: any) => p.key === currentKey);
          if (!found || !found.is_integrated) {
            this.selectedConferenceProvider = this.conferenceProviders.find((p: any) => p.is_integrated) || this.defaultJitsiProvider;
          }
          this.lastConnectedProvider = this.selectedConferenceProvider;
        }
        this.isLoadingProviders = false;
        this.providersLoaded = true;
      },
      error: () => {
        this.isLoadingProviders = false;
        this.providersLoaded = true;
      }
    });
  }

  navigateToSettings() {
    window.open('/settings?menu=integrations', '_blank');
  }

  onInterviewerPanelShow(event: any) {
    this.getRecruiterListByEvent();
  }

  getRecruiterListByEvent() {
    if (this.interviewerListLoaded && this.interviewerList.length > 0) {
      return;
    }
    
    this.eventServices.getRecruiterListByEventFastApi(this.eventId).subscribe({
      next: (response) => {
        this.interviewerList = [];
        const interviewers = response.body?.interviewers || [];
        
        if (Array.isArray(interviewers) && interviewers.length > 0) {
          interviewers.forEach((user: any) => {
            if (user && user.id && user.first_name && user.last_name) {
              this.interviewerList.push({ 
                label: `${user.first_name} ${user.last_name}`, 
                value: user.id, 
                userId: user.id,
                email: user.email || ''
              });
            }
          });
        }
        this.interviewerListLoaded = true;
      },
      error: (error) => {
        console.error('Error loading interviewers:', error);
        this.interviewerList = [];
        this.interviewerListLoaded = false;
      }
    });
  }

  onProviderSelectChange() {
    if (this.selectedConferenceProvider && !this.selectedConferenceProvider.is_integrated) {
      this.selectedConferenceProvider = this.lastConnectedProvider || this.defaultJitsiProvider;
      return;
    }
    if (this.selectedConferenceProvider?.is_integrated) {
      this.lastConnectedProvider = this.selectedConferenceProvider;
    }
    this.onProviderChange();
  }

  onProviderChange() {
    if (this.selectedConferenceProvider?.key !== 'ms_teams') {
      this.showAvailabilityPanel = false;
    }
  }

  toggleAvailabilityPanel() {
    this.showAvailabilityPanel = !this.showAvailabilityPanel;
    if (this.showAvailabilityPanel) {
      this.loadAvailability();
    }
  }

  initializeTimeSlots() {
    this.allTimeSlots = [];
    
    const formValue = this.sendLinkForm.value;
    let baseHour = 9;
    let baseMinute = 0;
    
    if (formValue.startTime?.value) {
      const [hours, minutes] = formValue.startTime.value.split(':');
      baseHour = parseInt(hours);
      baseMinute = parseInt(minutes);
      baseMinute = baseMinute < 30 ? 0 : 30;
    }    
    let startHour = baseHour - 6;
    let startMinute = baseMinute;    
    if (startHour < 0) {
      startHour += 24;
    }
    
    for (let i = 0; i < 24; i++) {
      let slotHour = startHour + Math.floor((startMinute + i * 30) / 60);
      let slotMinute = (startMinute + i * 30) % 60;
      
      slotHour = slotHour % 24;
      
      const h = slotHour.toString().padStart(2, '0');
      const m = slotMinute.toString().padStart(2, '0');
      this.allTimeSlots.push(`${h}:${m}`);
    }
    
    this.timelineScrollOffset = Math.max(0, 12 - Math.floor(this.visibleSlotsCount / 2));
  }

  get visibleTimeSlots(): string[] {
    return this.allTimeSlots.slice(this.timelineScrollOffset, this.timelineScrollOffset + this.visibleSlotsCount);
  }

  scrollTimelineLeft() {
    if (this.timelineScrollOffset > 0) {
      this.timelineScrollOffset = Math.max(0, this.timelineScrollOffset - 1);
    }
  }

  scrollTimelineRight() {
    if (this.timelineScrollOffset + this.visibleSlotsCount < this.allTimeSlots.length) {
      this.timelineScrollOffset = Math.min(this.allTimeSlots.length - this.visibleSlotsCount, this.timelineScrollOffset + 1);
    }
  }

  formatTimeSlot(time: string): string {
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const suffix = hour >= 12 ? 'pm' : 'am';
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${displayHour}${minutes === '00' ? '' : ':' + minutes} ${suffix}`;
  }

  onDateChangeForAvailability() {
    if (this.showAvailabilityPanel) {
      this.showAvailabilityPanel = false;
      this.availabilityData = [];
    }
  }

  onStartTimeChangeForAvailability() {
    if (this.showAvailabilityPanel && this.selectedConferenceProvider?.key === 'ms_teams') {
      this.loadAvailability();
    }
  }

  onInterviewerChangeForAvailability() {
    if (this.showAvailabilityPanel && this.selectedConferenceProvider?.key === 'ms_teams') {
      this.loadAvailability();
    }
  }

  loadAvailability() {
    if (this.selectedInterviewers.length === 0) {
      this.availabilityData = [];
      return;
    }

    const formValue = this.sendLinkForm.value;
    if (!formValue.interviewDate || !formValue.startTime) {
      this.availabilityData = [];
      return;
    }

    this.isLoadingAvailability = true;
    const formattedDate = moment(formValue.interviewDate).format('YYYY-MM-DD');
    const startTimeValue = formValue.startTime?.value || '09:00';
    const [hours, minutes] = startTimeValue.split(':');
    const hour = parseInt(hours);
    const minute = parseInt(minutes);    
    const validMinutes = [0, 15, 30, 45];
    const roundedMinute = validMinutes.reduce((prev, curr) => 
      Math.abs(curr - minute) < Math.abs(prev - minute) ? curr : prev
    );
    
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    const formattedTime = `${displayHour.toString().padStart(2, '0')}:${roundedMinute.toString().padStart(2, '0')} ${ampm}`;
    this.availabilityBaseHour = hour;
    this.availabilityBaseMinute = roundedMinute;

    this.initializeTimeSlots();

    const payload = {
      user_ids: this.selectedInterviewers,
      base_date: formattedDate,
      base_time: formattedTime
    };

    this.eventServices.getInterviewerAvailability(payload).subscribe({
      next: (response) => {
        this.availabilityData = [];
        const availabilityList = response.body?.availability || [];
        
        availabilityList.forEach((item: any) => {
          const availabilityString = item.availability_view || '';
          const availableSlots: number[] = [];
          for (let i = 0; i < availabilityString.length; i++) {
            if (availabilityString[i] === '0') {
              availableSlots.push(i);
            }
          }
          
          this.availabilityData.push({
            id: item.id,
            name: item.name || '',
            email: item.email || '',
            availability: availableSlots
          });
        });
        this.isLoadingAvailability = false;
      },
      error: (error) => {
        console.error('Error loading availability:', error);
        this.isLoadingAvailability = false;
        this.availabilityData = this.selectedInterviewers.map((interviewerId) => {
          const interviewer = this.interviewerList.find(i => i.value === interviewerId);
          return {
            id: interviewerId,
            name: interviewer?.label || '',
            email: interviewer?.email || '',
            availability: []
          };
        });
      }
    });
  }

  isSlotAvailable(interviewer: { id: number; availability: number[] }, slotIndex: number): boolean {
    return interviewer.availability.includes(slotIndex);
  }

  isCommonAvailableSlot(slotIndex: number): boolean {
    if (this.availabilityData.length === 0) return false;
    return this.availabilityData.every(interviewer => interviewer.availability.includes(slotIndex));
  }

  isSlotSelected(time: string): boolean {
    const formValue = this.sendLinkForm.value;
    if (!formValue.startTime) return false;
    return formValue.startTime.value === time;
  }

  selectTimeSlot(time: string) {
    const slot = this.timeSlots.find(s => s.value === time);
    if (slot) {
      this.sendLinkForm.patchValue({ startTime: slot });
    }
  }

  getFormattedAvailabilityDate(): string {
    const formValue = this.sendLinkForm.value;
    if (!formValue.interviewDate) return 'Select a date';
    return moment(formValue.interviewDate).format('dddd, MMMM D, YYYY');
  }

  getInterviewerName(interviewerId: number): string {
    const interviewer = this.interviewerList.find(i => i.value === interviewerId);
    return interviewer?.label || '';
  }

  getInterviewerInitials(interviewerId: number): string {
    const name = this.getInterviewerName(interviewerId);
    if (!name) return '';
    const parts = name.split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  getInterviewerAvatarColor(interviewerId: number): string {
    const colors = [
      '#7c3aed', '#2563eb', '#059669', '#d97706', '#dc2626',
      '#8b5cf6', '#0891b2', '#65a30d', '#ea580c', '#be185d'
    ];
    return colors[interviewerId % colors.length];
  }

  removeInterviewer(interviewerId: number) {
    this.selectedInterviewers = this.selectedInterviewers.filter(id => id !== interviewerId);
    if (this.showAvailabilityPanel) {
      this.loadAvailability();
    }
  }

  getProviderIcon(key: string): string {
    const iconMap: { [key: string]: string } = {
      'default': 'assets/icons-svg/Interview Icon.svg',
      'ms_teams': 'assets/icons-svg/teams.svg',
      'google_meet': 'assets/icons-svg/Gmeet.svg',
      'zoom': 'assets/icons-svg/zoom.svg'
    };
    return iconMap[key] || 'assets/icons-svg/configuration.svg';
  }

  getEventDetailsForJobRoles() {
    const sharedService = this.globalService.getSharedService();
    const request = sharedService.initiateEventDetailsRequest(
      this.eventId, 
      () => this.eventServices.getSpecificEventFastApi(this.eventId)
    );
    
    if (!request) {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Failed to initiate event details request",
      });
      return;
    }

    request.subscribe({
      next: (response: any) => {
        const fullEventData = response?.body ?? response;
        if (!sharedService.isEventDetailsLoaded(this.eventId)) {
          sharedService.setEventDetails(this.eventId, fullEventData);
        }
        this.handleInterviewJobRoles(fullEventData.event_details);
      },
      error: (_err: any) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Error fetching event details for job roles",
        });
      },
    });
  }

  handleInterviewJobRoles(eventDetails: any) {
    if (eventDetails?.job_roles && Array.isArray(eventDetails.job_roles)) {
      this.interviewJobRoles = eventDetails.job_roles.map((role: any) => ({
        label: role.name,
        value: role.id
      }));
      
      if (this.interviewJobRoles.length === 1) {
        this.sendLinkForm.patchValue({
          jobRoleId: this.interviewJobRoles[0].value
        });
      }
    } else {
      this.interviewJobRoles = [];
    }
  }

  loadAgents() {
    if (this.agents.length > 0) {
      return; // Already loaded
    }
    this.eventServices.getAgentsFastApi().subscribe({
      next: (response) => {
        if (response.status === 200 && response.body?.result) {
          this.agents = response.body.result.map((agent: any) => ({
            label: agent.name,
            value: agent.id
          }));
        }
      },
      error: (err) => {
        console.error('Error loading agents:', err);
      }
    });
  }

  hasValidPhoto(candidate: any): boolean {
    return candidate?.photo &&
      candidate.photo.trim() !== '' &&
      candidate.photo !== 'null' &&
      candidate.photo !== null;
  }

onImageError(event: any, candidate: any): void {
  event.target.style.display = 'none';
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'flex';
  }
  candidate._photoError = true;
}

onImageLoad(event: any): void {
  event.target.style.display = 'block';
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'none';
  }
}

getInitials(fullName: string): string {
  if (!fullName) return 'UN';
  
  const names = fullName.trim().split(' ').filter(name => name.length > 0);
  
  if (names.length === 0) return 'UN';
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  
  const firstInitial = names[0].charAt(0).toUpperCase();
  const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
  return firstInitial + lastInitial;
}

getAvatarColor(name: string): string {
  const colors = [
    '#FF6B35', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57', 
    '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43',
    '#EE5A24', '#009432', '#0652DD', '#9980FA', '#833471',
    '#F79F1F', '#A3CB38', '#1289A7', '#D63031', '#74B9FF'
  ];
  
  if (!name) return colors[0];
  
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return colors[Math.abs(hash) % colors.length];
}

getTruncatedId(fullId: string): string {
  if (!fullId) return '';
  
  if (fullId.length <= 13) {
    return fullId;
  }
  
  return fullId.substring(0, 13) + '...';
}


getStatusClass(status: string): string {
  if (!status) return 'status-default';
  
  const normalizedStatus = status
    .toLowerCase()
    .replace(/\s+/g, '-')           
    .replace(/[^a-z0-9-]/g, '')     
    .replace(/-+/g, '-')            
    .replace(/^-|-$/g, '');         
  
  return `status-${normalizedStatus}`;
}

copyToClipboard(text: string, label: string): void {
  if (!text) return;
  
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text.toString()).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    }).catch((err) => {
      console.error('Clipboard API failed:', err);
      this.fallbackCopyToClipboard(text.toString(), label);
    });
  } else {
    this.fallbackCopyToClipboard(text.toString(), label);
  }
}

private fallbackCopyToClipboard(text: string, label: string): void {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    }
  } catch (err) {
    console.error('Fallback copy failed:', err);
  } finally {
    document.body.removeChild(textArea);
  }
}
onClickSettingsSidebar(): void {
  this.showSettingsSidebar = true;
  this.showFilterSidebar = false;
  this.showDownloadSidebar = false;
}

toggleSelectAll() {
  if (this.selectAllColumns) {
    this.checkedColumns = [...this.colsToDownload];
  } else {
    this.checkedColumns = [];
  }
}

onColumnCheckChange() {
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}
get getActiveFilterCounts(): number {
  let activeCount = 0;
  for(let selectedColumn of this._selectedColumns) {
    if(selectedColumn?.options?.length) {
      if(selectedColumn?.selectedFilterElement) {
        if(selectedColumn.field !== "status") {
          activeCount += 1;
        } else {
          if(selectedColumn?.selectedFilterElement?.value !== "") {
            activeCount += 1;
          }
        }
      }
    }
  }

  if(this.filterFieldVisibility['isPWD']) {
    if(this.filterFieldTypes['isPWD'] === 'dropdown' && this.selectedPwd?.length) {
      activeCount += 1;
    } else if(this.filterFieldTypes['isPWD'] === 'input' && this.selectedPwdText?.length) {
      activeCount += 1;
    }
  }

  if(this.filterFieldVisibility['jobRole']) {
    if(this.filterFieldTypes['jobRole'] === 'dropdown' && this.selectedRole?.length) {
      activeCount += 1;
    } else if(this.filterFieldTypes['jobRole'] === 'input' && this.selectedRoleText?.length) {
      activeCount += 1;
    }
  }
  
  if(this.filterFieldVisibility['arrears']) {
    if(this.filterFieldTypes['arrears'] === 'dropdown' && this.selectedArrears?.length) {
      activeCount += 1;
    } else if(this.filterFieldTypes['arrears'] === 'input' && this.selectedArrearsText?.length) {
      activeCount += 1;
    }
  }

  if(this.filterFieldVisibility['gender']) {
    if(this.filterFieldTypes['gender'] === 'dropdown' && this.selectedGender?.length) {
      activeCount += 1;
    } else if(this.filterFieldTypes['gender'] === 'input' && this.selectedGenderText?.length) {
      activeCount += 1;
    }
  }
  
  if(this.filterFieldVisibility['graduationYear'] && (this.selectedYearDate)) {
    activeCount += 1
  }

  if(this.filterFieldVisibility['degreeBranch']) {
    if(this.filterFieldTypes['degreeBranch'] === 'dropdown' && this.selectedBranch?.length) {
      activeCount += 1;
    } else if(this.filterFieldTypes['degreeBranch'] === 'input' && this.selectedBranchText?.length) {
      activeCount += 1;
    }
  }

  if(this.filterFieldVisibility['degree']) {
    if(this.filterFieldTypes['degree'] === 'dropdown' && this.selectedDegree?.length) {
      activeCount += 1;
    } else if(this.filterFieldTypes['degree'] === 'input' && this.selectedDegreeText?.length) {
      activeCount += 1;
    }
  }

  if(this.filterFieldVisibility['collegeName'] ) {
    if(this.filterFieldTypes['collegeName'] === 'dropdown' && this.selectedCollege?.length) {
      activeCount += 1;
    } else if(this.filterFieldTypes['collegeName'] === 'input' && this.selectedCollegeText?.length) {
      activeCount += 1;
    }
  }
  
  return activeCount;
}
takeFilterBackup() {
  this.filterBackup["_selectedColumns"] = this._selectedColumns && [...JSON.parse(JSON.stringify(this._selectedColumns))]
  
  this.filterBackup["selectedPwd"] = this.selectedPwd && JSON.parse(JSON.stringify(this.selectedPwd))
  this.filterBackup["selectedPwdText"] = this.selectedPwdText && JSON.parse(JSON.stringify(this.selectedPwdText))
  
  this.filterBackup["selectedRole"] = this.selectedRole && JSON.parse(JSON.stringify(this.selectedRole))
  this.filterBackup["selectedRoleText"] = this.selectedRoleText && JSON.parse(JSON.stringify(this.selectedRoleText))
  
  this.filterBackup["selectedArrears"] = this.selectedArrears && JSON.parse(JSON.stringify(this.selectedArrears))
  this.filterBackup["selectedArrearsText"] = this.selectedArrearsText && JSON.parse(JSON.stringify(this.selectedArrearsText))
  
  this.filterBackup["selectedGender"] = this.selectedGender && JSON.parse(JSON.stringify(this.selectedGender))
  this.filterBackup["selectedGenderText"] = this.selectedGenderText && JSON.parse(JSON.stringify(this.selectedGenderText))
  
  this.filterBackup["selectedYearDate"] = this.selectedYearDate && this.selectedYearDate
  this.filterBackup["selectedBranch"] = this.selectedBranch && JSON.parse(JSON.stringify(this.selectedBranch))
  this.filterBackup["selectedBranchText"] = this.selectedBranchText && JSON.parse(JSON.stringify(this.selectedBranchText))
  this.filterBackup["selectedDegree"] = this.selectedDegree && JSON.parse(JSON.stringify(this.selectedDegree))
  this.filterBackup["selectedDegreeText"] = this.selectedDegreeText && JSON.parse(JSON.stringify(this.selectedDegreeText))
  
  this.filterBackup["selectedCollege"] = this.selectedCollege && JSON.parse(JSON.stringify(this.selectedCollege))
  this.filterBackup["selectedCollegeText"] = this.selectedCollegeText && JSON.parse(JSON.stringify(this.selectedCollegeText))
  
  this.filterBackup["rangeDates"] = this.rangeDates && JSON.parse(JSON.stringify(this.rangeDates))
}
cancelFilter(): void {
  if (this._selectedColumns) {
    this._selectedColumns.forEach(col => {
      if (col.selectedFilterElement) {
        const selectedColumnsBackup = this.filterBackup["_selectedColumns"]?.find((colbackup: any) => colbackup.field === col.field);
        if(selectedColumnsBackup) {
          col.selectedFilterElement = selectedColumnsBackup.selectedFilterElement;
        } else {
          col.selectedFilterElement = null;
        }
      }
    });
  }

  this.selectedPwd = this.filterBackup["selectedPwd"] || null;
  this.selectedPwdText = this.filterBackup["selectedPwdText"] || '';

  this.selectedRole = this.filterBackup["selectedRole"] || [];
  this.selectedRoleText = this.filterBackup["selectedRoleText"] || '';

  this.selectedArrears = this.filterBackup["selectedArrears"] || null;
  this.selectedArrearsText = this.filterBackup["selectedArrearsText"] || '';

  this.selectedGender = this.filterBackup["selectedGender"] || null;
  this.selectedGenderText = this.filterBackup["selectedGenderText"] || '';

  this.selectedYearDate = this.filterBackup["selectedYearDate"] || null;
  this.selectedBranch = this.filterBackup["selectedBranch"] || [];
  this.selectedDegree = this.filterBackup["selectedDegree"] || [];
  this.selectedBranchText = this.filterBackup["selectedBranchText"] || '';

  this.selectedCollege = this.filterBackup["selectedCollege"] || [];
  this.selectedCollegeText = this.filterBackup["selectedCollegeText"] || '';

  this.rangeDates = this.filterBackup["rangeDates"] || null;

  this.showFilterSidebar = false;
}
  resetCheckedColumnsToDefault(): void {
    this.checkedColumns = [...this._selectedColumns];
    this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
  }

  institutionsPage: number = 1;
  hasMoreInstitutions: boolean = true;
  loadingInstitutions: boolean = false;
  institutionsSearchQuery: string = "";
  currentDropdownSelect: MultiSelect | null = null;

  onInstitutionDropdownShow(event: any, selectel: MultiSelect) {
    this.currentDropdownSelect = selectel;
    setTimeout(() => {
      const dropdownPanels = document.querySelectorAll('.p-multiselect-overlay .p-multiselect-list-container');
      dropdownPanels.forEach(panel => {
        panel.addEventListener('scroll', this.handleDropdownScroll.bind(this));
      });
    }, 200);
  }

  onInstitutionDropdownHide(event: any) {
    const dropdownPanels = document.querySelectorAll('.p-multiselect-overlay .p-multiselect-list-container');
    dropdownPanels.forEach(panel => {
      panel.removeEventListener('scroll', this.handleDropdownScroll.bind(this));
    });
  }

  handleDropdownScroll(event: any) {
    const element = event.target;
    const threshold = 100;

    if (element.scrollTop + element.clientHeight >= element.scrollHeight - threshold) {
      if (this.hasMoreInstitutions && !this.loadingInstitutions) {
        setTimeout(() => {
          if (this.hasMoreInstitutions && !this.loadingInstitutions) {
            this.institutionsPage++;
            this.getInstitutions();
          }
        }, 300);
      }
    }
  }

  getInstitutions() {
    this.loadingInstitutions = true;
    const params: any = { page: this.institutionsPage, s: this.institutionsSearchQuery };
    if (!this.institutionsSearchQuery) {
      delete params.s;
    }

    this.formBuilderService.getEventSpecificFormDetailsFastApi(this.eventId, { includeInstitutes: true }, params).pipe(takeUntil(this.instituteSearch$)).subscribe((res) => {
      const institutions = res.body.institutes;
      let items: any[] = institutions.items || [];

      if (items) {
        if (items.length) {
          items = items.filter((item) => item.name?.toLowerCase() !== "others" && item.state?.toLowerCase() !== "others" && item.city?.toLowerCase() !== "others")
          let updatedItems = this.formBuilderService.mapFieldOptions('institute', items, ['name', 'city', 'state'], ['name', 'city', 'state'])
          updatedItems = updatedItems.filter((item) => {
            const exists = (this.collegeList as any[]).some(
              (coll: any) => coll.label === item.label && coll.value === item.value
            );

            return !exists;
          });
          this.collegeList = [...this.collegeList, ...updatedItems];
        }

        if (items.length < institutions.size) {
          this.hasMoreInstitutions = false;
        }
      } else {
        this.hasMoreInstitutions = false;
      }

      realignMultiSelectOverlay(this.currentDropdownSelect);
      this.loadingInstitutions = false;
    }, (err) => {
      this.loadingInstitutions = false;
      this.hasMoreInstitutions = true;
    })
  }

  getTestScoreValue(candidate: any, stageId: string): number {
    const testScore = this.getTestScoreByStageId(candidate, stageId);
    return testScore?.marks ?? -1;
  }

  customSort(event: any) {
    const { field, order } = event;

    // Handle Test Score separately
    if (field === 'testScore') {
      this.candidateList.sort((a: any, b: any) => {
        const scoreA = this.getTestScoreValue(a, this.stage.stageId);
        const scoreB = this.getTestScoreValue(b, this.stage.stageId);

        return (scoreA - scoreB) * order;
      });

      return;
    }

    // Default sorting for normal columns
    this.candidateList.sort((a: any, b: any) => {
      const valueA = a[field];
      const valueB = b[field];

      if (valueA == null) return -1 * order;
      if (valueB == null) return 1 * order;

      return valueA > valueB ? order : valueA < valueB ? -order : 0;
    });
  }

  handleFeedbackClick(event: any, candidate: any) {
    if(!candidate.isFeedbackSubmitted && candidate['status']?.toLowerCase() === 'completed') {
      event.stopPropagation(); 
      this.onFeedbackIconClick(candidate)
    }

    if(candidate.isFeedbackSubmitted) {
      event.stopPropagation(); 
      this.onFeedbackIconClick(candidate)
    }
  }
}
